import Ge, { useCallback as $e, createContext as ga, useContext as wa, memo as Ea } from "react";
import tt from "react-ga4";
var Sa = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ra(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var cr = {}, Mo = {}, dr = {}, ur = { exports: {} }, ne = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wr;
function Oa() {
  if (Wr)
    return ne;
  Wr = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, i = e ? Symbol.for("react.context") : 60110, m = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, b = e ? Symbol.for("react.suspense") : 60113, c = e ? Symbol.for("react.suspense_list") : 60120, d = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, u = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
  function h(p) {
    if (typeof p == "object" && p !== null) {
      var P = p.$$typeof;
      switch (P) {
        case t:
          switch (p = p.type, p) {
            case m:
            case l:
            case n:
            case a:
            case o:
            case b:
              return p;
            default:
              switch (p = p && p.$$typeof, p) {
                case i:
                case f:
                case v:
                case d:
                case s:
                  return p;
                default:
                  return P;
              }
          }
        case r:
          return P;
      }
    }
  }
  function g(p) {
    return h(p) === l;
  }
  return ne.AsyncMode = m, ne.ConcurrentMode = l, ne.ContextConsumer = i, ne.ContextProvider = s, ne.Element = t, ne.ForwardRef = f, ne.Fragment = n, ne.Lazy = v, ne.Memo = d, ne.Portal = r, ne.Profiler = a, ne.StrictMode = o, ne.Suspense = b, ne.isAsyncMode = function(p) {
    return g(p) || h(p) === m;
  }, ne.isConcurrentMode = g, ne.isContextConsumer = function(p) {
    return h(p) === i;
  }, ne.isContextProvider = function(p) {
    return h(p) === s;
  }, ne.isElement = function(p) {
    return typeof p == "object" && p !== null && p.$$typeof === t;
  }, ne.isForwardRef = function(p) {
    return h(p) === f;
  }, ne.isFragment = function(p) {
    return h(p) === n;
  }, ne.isLazy = function(p) {
    return h(p) === v;
  }, ne.isMemo = function(p) {
    return h(p) === d;
  }, ne.isPortal = function(p) {
    return h(p) === r;
  }, ne.isProfiler = function(p) {
    return h(p) === a;
  }, ne.isStrictMode = function(p) {
    return h(p) === o;
  }, ne.isSuspense = function(p) {
    return h(p) === b;
  }, ne.isValidElementType = function(p) {
    return typeof p == "string" || typeof p == "function" || p === n || p === l || p === a || p === o || p === b || p === c || typeof p == "object" && p !== null && (p.$$typeof === v || p.$$typeof === d || p.$$typeof === s || p.$$typeof === i || p.$$typeof === f || p.$$typeof === y || p.$$typeof === S || p.$$typeof === w || p.$$typeof === u);
  }, ne.typeOf = h, ne;
}
var oe = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yr;
function _a() {
  return Yr || (Yr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, i = e ? Symbol.for("react.context") : 60110, m = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, b = e ? Symbol.for("react.suspense") : 60113, c = e ? Symbol.for("react.suspense_list") : 60120, d = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, u = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
    function h(R) {
      return typeof R == "string" || typeof R == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      R === n || R === l || R === a || R === o || R === b || R === c || typeof R == "object" && R !== null && (R.$$typeof === v || R.$$typeof === d || R.$$typeof === s || R.$$typeof === i || R.$$typeof === f || R.$$typeof === y || R.$$typeof === S || R.$$typeof === w || R.$$typeof === u);
    }
    function g(R) {
      if (typeof R == "object" && R !== null) {
        var $ = R.$$typeof;
        switch ($) {
          case t:
            var pe = R.type;
            switch (pe) {
              case m:
              case l:
              case n:
              case a:
              case o:
              case b:
                return pe;
              default:
                var de = pe && pe.$$typeof;
                switch (de) {
                  case i:
                  case f:
                  case v:
                  case d:
                  case s:
                    return de;
                  default:
                    return $;
                }
            }
          case r:
            return $;
        }
      }
    }
    var p = m, P = l, _ = i, A = s, Y = t, q = f, X = n, J = v, H = d, Z = r, K = a, j = o, ue = b, se = !1;
    function ve(R) {
      return se || (se = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), T(R) || g(R) === m;
    }
    function T(R) {
      return g(R) === l;
    }
    function C(R) {
      return g(R) === i;
    }
    function F(R) {
      return g(R) === s;
    }
    function M(R) {
      return typeof R == "object" && R !== null && R.$$typeof === t;
    }
    function L(R) {
      return g(R) === f;
    }
    function V(R) {
      return g(R) === n;
    }
    function D(R) {
      return g(R) === v;
    }
    function I(R) {
      return g(R) === d;
    }
    function G(R) {
      return g(R) === r;
    }
    function x(R) {
      return g(R) === a;
    }
    function k(R) {
      return g(R) === o;
    }
    function N(R) {
      return g(R) === b;
    }
    oe.AsyncMode = p, oe.ConcurrentMode = P, oe.ContextConsumer = _, oe.ContextProvider = A, oe.Element = Y, oe.ForwardRef = q, oe.Fragment = X, oe.Lazy = J, oe.Memo = H, oe.Portal = Z, oe.Profiler = K, oe.StrictMode = j, oe.Suspense = ue, oe.isAsyncMode = ve, oe.isConcurrentMode = T, oe.isContextConsumer = C, oe.isContextProvider = F, oe.isElement = M, oe.isForwardRef = L, oe.isFragment = V, oe.isLazy = D, oe.isMemo = I, oe.isPortal = G, oe.isProfiler = x, oe.isStrictMode = k, oe.isSuspense = N, oe.isValidElementType = h, oe.typeOf = g;
  }()), oe;
}
process.env.NODE_ENV === "production" ? ur.exports = Oa() : ur.exports = _a();
var Ta = ur.exports, yr = Ta, Pa = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, Aa = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, Ca = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, jo = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, vr = {};
vr[yr.ForwardRef] = Ca;
vr[yr.Memo] = jo;
function Gr(e) {
  return yr.isMemo(e) ? jo : vr[e.$$typeof] || Pa;
}
var xa = Object.defineProperty, ka = Object.getOwnPropertyNames, Ur = Object.getOwnPropertySymbols, Ma = Object.getOwnPropertyDescriptor, ja = Object.getPrototypeOf, Br = Object.prototype;
function Io(e, t, r) {
  if (typeof t != "string") {
    if (Br) {
      var n = ja(t);
      n && n !== Br && Io(e, n, r);
    }
    var o = ka(t);
    Ur && (o = o.concat(Ur(t)));
    for (var a = Gr(e), s = Gr(t), i = 0; i < o.length; ++i) {
      var m = o[i];
      if (!Aa[m] && !(r && r[m]) && !(s && s[m]) && !(a && a[m])) {
        var l = Ma(t, m);
        try {
          xa(e, m, l);
        } catch {
        }
      }
    }
  }
  return e;
}
var Ia = Io, sr = { exports: {} }, st = { exports: {} }, ae = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zr;
function La() {
  if (zr)
    return ae;
  zr = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, i = e ? Symbol.for("react.context") : 60110, m = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, b = e ? Symbol.for("react.suspense") : 60113, c = e ? Symbol.for("react.suspense_list") : 60120, d = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, u = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
  function h(p) {
    if (typeof p == "object" && p !== null) {
      var P = p.$$typeof;
      switch (P) {
        case t:
          switch (p = p.type, p) {
            case m:
            case l:
            case n:
            case a:
            case o:
            case b:
              return p;
            default:
              switch (p = p && p.$$typeof, p) {
                case i:
                case f:
                case v:
                case d:
                case s:
                  return p;
                default:
                  return P;
              }
          }
        case r:
          return P;
      }
    }
  }
  function g(p) {
    return h(p) === l;
  }
  return ae.AsyncMode = m, ae.ConcurrentMode = l, ae.ContextConsumer = i, ae.ContextProvider = s, ae.Element = t, ae.ForwardRef = f, ae.Fragment = n, ae.Lazy = v, ae.Memo = d, ae.Portal = r, ae.Profiler = a, ae.StrictMode = o, ae.Suspense = b, ae.isAsyncMode = function(p) {
    return g(p) || h(p) === m;
  }, ae.isConcurrentMode = g, ae.isContextConsumer = function(p) {
    return h(p) === i;
  }, ae.isContextProvider = function(p) {
    return h(p) === s;
  }, ae.isElement = function(p) {
    return typeof p == "object" && p !== null && p.$$typeof === t;
  }, ae.isForwardRef = function(p) {
    return h(p) === f;
  }, ae.isFragment = function(p) {
    return h(p) === n;
  }, ae.isLazy = function(p) {
    return h(p) === v;
  }, ae.isMemo = function(p) {
    return h(p) === d;
  }, ae.isPortal = function(p) {
    return h(p) === r;
  }, ae.isProfiler = function(p) {
    return h(p) === a;
  }, ae.isStrictMode = function(p) {
    return h(p) === o;
  }, ae.isSuspense = function(p) {
    return h(p) === b;
  }, ae.isValidElementType = function(p) {
    return typeof p == "string" || typeof p == "function" || p === n || p === l || p === a || p === o || p === b || p === c || typeof p == "object" && p !== null && (p.$$typeof === v || p.$$typeof === d || p.$$typeof === s || p.$$typeof === i || p.$$typeof === f || p.$$typeof === y || p.$$typeof === S || p.$$typeof === w || p.$$typeof === u);
  }, ae.typeOf = h, ae;
}
var ie = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zr;
function Da() {
  return Zr || (Zr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, i = e ? Symbol.for("react.context") : 60110, m = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, b = e ? Symbol.for("react.suspense") : 60113, c = e ? Symbol.for("react.suspense_list") : 60120, d = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, u = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
    function h(R) {
      return typeof R == "string" || typeof R == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      R === n || R === l || R === a || R === o || R === b || R === c || typeof R == "object" && R !== null && (R.$$typeof === v || R.$$typeof === d || R.$$typeof === s || R.$$typeof === i || R.$$typeof === f || R.$$typeof === y || R.$$typeof === S || R.$$typeof === w || R.$$typeof === u);
    }
    function g(R) {
      if (typeof R == "object" && R !== null) {
        var $ = R.$$typeof;
        switch ($) {
          case t:
            var pe = R.type;
            switch (pe) {
              case m:
              case l:
              case n:
              case a:
              case o:
              case b:
                return pe;
              default:
                var de = pe && pe.$$typeof;
                switch (de) {
                  case i:
                  case f:
                  case v:
                  case d:
                  case s:
                    return de;
                  default:
                    return $;
                }
            }
          case r:
            return $;
        }
      }
    }
    var p = m, P = l, _ = i, A = s, Y = t, q = f, X = n, J = v, H = d, Z = r, K = a, j = o, ue = b, se = !1;
    function ve(R) {
      return se || (se = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), T(R) || g(R) === m;
    }
    function T(R) {
      return g(R) === l;
    }
    function C(R) {
      return g(R) === i;
    }
    function F(R) {
      return g(R) === s;
    }
    function M(R) {
      return typeof R == "object" && R !== null && R.$$typeof === t;
    }
    function L(R) {
      return g(R) === f;
    }
    function V(R) {
      return g(R) === n;
    }
    function D(R) {
      return g(R) === v;
    }
    function I(R) {
      return g(R) === d;
    }
    function G(R) {
      return g(R) === r;
    }
    function x(R) {
      return g(R) === a;
    }
    function k(R) {
      return g(R) === o;
    }
    function N(R) {
      return g(R) === b;
    }
    ie.AsyncMode = p, ie.ConcurrentMode = P, ie.ContextConsumer = _, ie.ContextProvider = A, ie.Element = Y, ie.ForwardRef = q, ie.Fragment = X, ie.Lazy = J, ie.Memo = H, ie.Portal = Z, ie.Profiler = K, ie.StrictMode = j, ie.Suspense = ue, ie.isAsyncMode = ve, ie.isConcurrentMode = T, ie.isContextConsumer = C, ie.isContextProvider = F, ie.isElement = M, ie.isForwardRef = L, ie.isFragment = V, ie.isLazy = D, ie.isMemo = I, ie.isPortal = G, ie.isProfiler = x, ie.isStrictMode = k, ie.isSuspense = N, ie.isValidElementType = h, ie.typeOf = g;
  }()), ie;
}
var qr;
function Lo() {
  return qr || (qr = 1, process.env.NODE_ENV === "production" ? st.exports = La() : st.exports = Da()), st.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Rt, Hr;
function Fa() {
  if (Hr)
    return Rt;
  Hr = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var s = {}, i = 0; i < 10; i++)
        s["_" + String.fromCharCode(i)] = i;
      var m = Object.getOwnPropertyNames(s).map(function(f) {
        return s[f];
      });
      if (m.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        l[f] = f;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Rt = o() ? Object.assign : function(a, s) {
    for (var i, m = n(a), l, f = 1; f < arguments.length; f++) {
      i = Object(arguments[f]);
      for (var b in i)
        t.call(i, b) && (m[b] = i[b]);
      if (e) {
        l = e(i);
        for (var c = 0; c < l.length; c++)
          r.call(i, l[c]) && (m[l[c]] = i[l[c]]);
      }
    }
    return m;
  }, Rt;
}
var Ot, $r;
function mr() {
  if ($r)
    return Ot;
  $r = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ot = e, Ot;
}
var _t, Xr;
function Do() {
  return Xr || (Xr = 1, _t = Function.call.bind(Object.prototype.hasOwnProperty)), _t;
}
var Tt, Jr;
function Na() {
  if (Jr)
    return Tt;
  Jr = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = mr(), r = {}, n = Do();
    e = function(a) {
      var s = "Warning: " + a;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function o(a, s, i, m, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in a)
        if (n(a, f)) {
          var b;
          try {
            if (typeof a[f] != "function") {
              var c = Error(
                (m || "React class") + ": " + i + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw c.name = "Invariant Violation", c;
            }
            b = a[f](s, f, m, i, null, t);
          } catch (v) {
            b = v;
          }
          if (b && !(b instanceof Error) && e(
            (m || "React class") + ": type specification of " + i + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof b + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), b instanceof Error && !(b.message in r)) {
            r[b.message] = !0;
            var d = l ? l() : "";
            e(
              "Failed " + i + " type: " + b.message + (d ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Tt = o, Tt;
}
var Pt, Kr;
function Va() {
  if (Kr)
    return Pt;
  Kr = 1;
  var e = Lo(), t = Fa(), r = mr(), n = Do(), o = Na(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(i) {
    var m = "Warning: " + i;
    typeof console < "u" && console.error(m);
    try {
      throw new Error(m);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return Pt = function(i, m) {
    var l = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function b(T) {
      var C = T && (l && T[l] || T[f]);
      if (typeof C == "function")
        return C;
    }
    var c = "<<anonymous>>", d = {
      array: S("array"),
      bigint: S("bigint"),
      bool: S("boolean"),
      func: S("function"),
      number: S("number"),
      object: S("object"),
      string: S("string"),
      symbol: S("symbol"),
      any: w(),
      arrayOf: h,
      element: g(),
      elementType: p(),
      instanceOf: P,
      node: q(),
      objectOf: A,
      oneOf: _,
      oneOfType: Y,
      shape: J,
      exact: H
    };
    function v(T, C) {
      return T === C ? T !== 0 || 1 / T === 1 / C : T !== T && C !== C;
    }
    function u(T, C) {
      this.message = T, this.data = C && typeof C == "object" ? C : {}, this.stack = "";
    }
    u.prototype = Error.prototype;
    function y(T) {
      if (process.env.NODE_ENV !== "production")
        var C = {}, F = 0;
      function M(V, D, I, G, x, k, N) {
        if (G = G || c, k = k || I, N !== r) {
          if (m) {
            var R = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw R.name = "Invariant Violation", R;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var $ = G + ":" + I;
            !C[$] && // Avoid spamming the console because they are often not actionable except for lib authors
            F < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + k + "` prop on `" + G + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), C[$] = !0, F++);
          }
        }
        return D[I] == null ? V ? D[I] === null ? new u("The " + x + " `" + k + "` is marked as required " + ("in `" + G + "`, but its value is `null`.")) : new u("The " + x + " `" + k + "` is marked as required in " + ("`" + G + "`, but its value is `undefined`.")) : null : T(D, I, G, x, k);
      }
      var L = M.bind(null, !1);
      return L.isRequired = M.bind(null, !0), L;
    }
    function S(T) {
      function C(F, M, L, V, D, I) {
        var G = F[M], x = j(G);
        if (x !== T) {
          var k = ue(G);
          return new u(
            "Invalid " + V + " `" + D + "` of type " + ("`" + k + "` supplied to `" + L + "`, expected ") + ("`" + T + "`."),
            { expectedType: T }
          );
        }
        return null;
      }
      return y(C);
    }
    function w() {
      return y(s);
    }
    function h(T) {
      function C(F, M, L, V, D) {
        if (typeof T != "function")
          return new u("Property `" + D + "` of component `" + L + "` has invalid PropType notation inside arrayOf.");
        var I = F[M];
        if (!Array.isArray(I)) {
          var G = j(I);
          return new u("Invalid " + V + " `" + D + "` of type " + ("`" + G + "` supplied to `" + L + "`, expected an array."));
        }
        for (var x = 0; x < I.length; x++) {
          var k = T(I, x, L, V, D + "[" + x + "]", r);
          if (k instanceof Error)
            return k;
        }
        return null;
      }
      return y(C);
    }
    function g() {
      function T(C, F, M, L, V) {
        var D = C[F];
        if (!i(D)) {
          var I = j(D);
          return new u("Invalid " + L + " `" + V + "` of type " + ("`" + I + "` supplied to `" + M + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(T);
    }
    function p() {
      function T(C, F, M, L, V) {
        var D = C[F];
        if (!e.isValidElementType(D)) {
          var I = j(D);
          return new u("Invalid " + L + " `" + V + "` of type " + ("`" + I + "` supplied to `" + M + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(T);
    }
    function P(T) {
      function C(F, M, L, V, D) {
        if (!(F[M] instanceof T)) {
          var I = T.name || c, G = ve(F[M]);
          return new u("Invalid " + V + " `" + D + "` of type " + ("`" + G + "` supplied to `" + L + "`, expected ") + ("instance of `" + I + "`."));
        }
        return null;
      }
      return y(C);
    }
    function _(T) {
      if (!Array.isArray(T))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), s;
      function C(F, M, L, V, D) {
        for (var I = F[M], G = 0; G < T.length; G++)
          if (v(I, T[G]))
            return null;
        var x = JSON.stringify(T, function(N, R) {
          var $ = ue(R);
          return $ === "symbol" ? String(R) : R;
        });
        return new u("Invalid " + V + " `" + D + "` of value `" + String(I) + "` " + ("supplied to `" + L + "`, expected one of " + x + "."));
      }
      return y(C);
    }
    function A(T) {
      function C(F, M, L, V, D) {
        if (typeof T != "function")
          return new u("Property `" + D + "` of component `" + L + "` has invalid PropType notation inside objectOf.");
        var I = F[M], G = j(I);
        if (G !== "object")
          return new u("Invalid " + V + " `" + D + "` of type " + ("`" + G + "` supplied to `" + L + "`, expected an object."));
        for (var x in I)
          if (n(I, x)) {
            var k = T(I, x, L, V, D + "." + x, r);
            if (k instanceof Error)
              return k;
          }
        return null;
      }
      return y(C);
    }
    function Y(T) {
      if (!Array.isArray(T))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var C = 0; C < T.length; C++) {
        var F = T[C];
        if (typeof F != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + se(F) + " at index " + C + "."
          ), s;
      }
      function M(L, V, D, I, G) {
        for (var x = [], k = 0; k < T.length; k++) {
          var N = T[k], R = N(L, V, D, I, G, r);
          if (R == null)
            return null;
          R.data && n(R.data, "expectedType") && x.push(R.data.expectedType);
        }
        var $ = x.length > 0 ? ", expected one of type [" + x.join(", ") + "]" : "";
        return new u("Invalid " + I + " `" + G + "` supplied to " + ("`" + D + "`" + $ + "."));
      }
      return y(M);
    }
    function q() {
      function T(C, F, M, L, V) {
        return Z(C[F]) ? null : new u("Invalid " + L + " `" + V + "` supplied to " + ("`" + M + "`, expected a ReactNode."));
      }
      return y(T);
    }
    function X(T, C, F, M, L) {
      return new u(
        (T || "React class") + ": " + C + " type `" + F + "." + M + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + L + "`."
      );
    }
    function J(T) {
      function C(F, M, L, V, D) {
        var I = F[M], G = j(I);
        if (G !== "object")
          return new u("Invalid " + V + " `" + D + "` of type `" + G + "` " + ("supplied to `" + L + "`, expected `object`."));
        for (var x in T) {
          var k = T[x];
          if (typeof k != "function")
            return X(L, V, D, x, ue(k));
          var N = k(I, x, L, V, D + "." + x, r);
          if (N)
            return N;
        }
        return null;
      }
      return y(C);
    }
    function H(T) {
      function C(F, M, L, V, D) {
        var I = F[M], G = j(I);
        if (G !== "object")
          return new u("Invalid " + V + " `" + D + "` of type `" + G + "` " + ("supplied to `" + L + "`, expected `object`."));
        var x = t({}, F[M], T);
        for (var k in x) {
          var N = T[k];
          if (n(T, k) && typeof N != "function")
            return X(L, V, D, k, ue(N));
          if (!N)
            return new u(
              "Invalid " + V + " `" + D + "` key `" + k + "` supplied to `" + L + "`.\nBad object: " + JSON.stringify(F[M], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(T), null, "  ")
            );
          var R = N(I, k, L, V, D + "." + k, r);
          if (R)
            return R;
        }
        return null;
      }
      return y(C);
    }
    function Z(T) {
      switch (typeof T) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !T;
        case "object":
          if (Array.isArray(T))
            return T.every(Z);
          if (T === null || i(T))
            return !0;
          var C = b(T);
          if (C) {
            var F = C.call(T), M;
            if (C !== T.entries) {
              for (; !(M = F.next()).done; )
                if (!Z(M.value))
                  return !1;
            } else
              for (; !(M = F.next()).done; ) {
                var L = M.value;
                if (L && !Z(L[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function K(T, C) {
      return T === "symbol" ? !0 : C ? C["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && C instanceof Symbol : !1;
    }
    function j(T) {
      var C = typeof T;
      return Array.isArray(T) ? "array" : T instanceof RegExp ? "object" : K(C, T) ? "symbol" : C;
    }
    function ue(T) {
      if (typeof T > "u" || T === null)
        return "" + T;
      var C = j(T);
      if (C === "object") {
        if (T instanceof Date)
          return "date";
        if (T instanceof RegExp)
          return "regexp";
      }
      return C;
    }
    function se(T) {
      var C = ue(T);
      switch (C) {
        case "array":
        case "object":
          return "an " + C;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + C;
        default:
          return C;
      }
    }
    function ve(T) {
      return !T.constructor || !T.constructor.name ? c : T.constructor.name;
    }
    return d.checkPropTypes = o, d.resetWarningCache = o.resetWarningCache, d.PropTypes = d, d;
  }, Pt;
}
var At, Qr;
function Wa() {
  if (Qr)
    return At;
  Qr = 1;
  var e = mr();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, At = function() {
    function n(s, i, m, l, f, b) {
      if (b !== e) {
        var c = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw c.name = "Invariant Violation", c;
      }
    }
    n.isRequired = n;
    function o() {
      return n;
    }
    var a = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: o,
      element: n,
      elementType: n,
      instanceOf: o,
      node: n,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, At;
}
if (process.env.NODE_ENV !== "production") {
  var Ya = Lo(), Ga = !0;
  sr.exports = Va()(Ya.isElement, Ga);
} else
  sr.exports = Wa()();
var Fo = sr.exports, pt = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var t = r(Ge);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var n = t.default.createContext({});
  e.default = n;
})(pt);
var br = {}, Ua = function(t) {
  return Ba(t) && !za(t);
};
function Ba(e) {
  return !!e && typeof e == "object";
}
function za(e) {
  var t = Object.prototype.toString.call(e);
  return t === "[object RegExp]" || t === "[object Date]" || Ha(e);
}
var Za = typeof Symbol == "function" && Symbol.for, qa = Za ? Symbol.for("react.element") : 60103;
function Ha(e) {
  return e.$$typeof === qa;
}
function $a(e) {
  return Array.isArray(e) ? [] : {};
}
function rt(e, t) {
  return t.clone !== !1 && t.isMergeableObject(e) ? Xe($a(e), e, t) : e;
}
function Xa(e, t, r) {
  return e.concat(t).map(function(n) {
    return rt(n, r);
  });
}
function Ja(e, t) {
  if (!t.customMerge)
    return Xe;
  var r = t.customMerge(e);
  return typeof r == "function" ? r : Xe;
}
function Ka(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
    return Object.propertyIsEnumerable.call(e, t);
  }) : [];
}
function en(e) {
  return Object.keys(e).concat(Ka(e));
}
function No(e, t) {
  try {
    return t in e;
  } catch {
    return !1;
  }
}
function Qa(e, t) {
  return No(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
}
function ei(e, t, r) {
  var n = {};
  return r.isMergeableObject(e) && en(e).forEach(function(o) {
    n[o] = rt(e[o], r);
  }), en(t).forEach(function(o) {
    Qa(e, o) || (No(e, o) && r.isMergeableObject(t[o]) ? n[o] = Ja(o, r)(e[o], t[o], r) : n[o] = rt(t[o], r));
  }), n;
}
function Xe(e, t, r) {
  r = r || {}, r.arrayMerge = r.arrayMerge || Xa, r.isMergeableObject = r.isMergeableObject || Ua, r.cloneUnlessOtherwiseSpecified = rt;
  var n = Array.isArray(t), o = Array.isArray(e), a = n === o;
  return a ? n ? r.arrayMerge(e, t, r) : ei(e, t, r) : rt(t, r);
}
Xe.all = function(t, r) {
  if (!Array.isArray(t))
    throw new Error("first argument should be an array");
  return t.reduce(function(n, o) {
    return Xe(n, o, r);
  }, {});
};
var ti = Xe, Vo = ti, Wo = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = t;
  function t(r) {
    typeof window < "u" && Object.keys(r).length > 0 && (window.dataLayer = window.dataLayer || []).push(r);
  }
})(Wo);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = s;
  var t = Ge, r = a(Vo), n = a(pt), o = a(Wo);
  function a(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function s(i, m) {
    var l = (0, t.useContext)(n.default), f = l.tracking, b = (0, t.useRef)(i), c = (0, t.useRef)(m);
    (0, t.useEffect)(function() {
      b.current = i, c.current = m;
    });
    var d = (0, t.useMemo)(function() {
      return c.current || {};
    }, []), v = d.dispatch, u = v === void 0 ? o.default : v, y = d.dispatchOnMount, S = y === void 0 ? !1 : y, w = d.process, h = (0, t.useCallback)(function() {
      return f && f.process;
    }, [f]), g = (0, t.useCallback)(function() {
      var A = b.current, Y = typeof A == "function" ? A() : A;
      return Y || {};
    }, []), p = (0, t.useCallback)(function() {
      var A = f && f.getTrackingData || g;
      return function() {
        return A === g ? g() : (0, r.default)(A(), g(), (c.current || {}).mergeOptions);
      };
    }, [g, f]), P = (0, t.useCallback)(function() {
      var A = f && f.dispatch || u;
      return function(Y) {
        return A((0, r.default)(g(), Y || {}, (c.current || {}).mergeOptions));
      };
    }, [g, f, u]), _ = (0, t.useCallback)(function() {
      var A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      P()(A);
    }, [P]);
    return (0, t.useEffect)(function() {
      var A = h(), Y = p();
      if (A && w && console.error("[react-tracking] options.process should be defined once on a top-level component"), typeof A == "function" && typeof S == "function")
        _((0, r.default)(A(g()) || {}, S(Y()) || {}, (c.current || {}).mergeOptions));
      else if (typeof A == "function") {
        var q = A(g());
        (q || S === !0) && _(q);
      } else
        typeof S == "function" ? _(S(Y())) : S === !0 && _();
    }, [g, h, p, _, S, w]), (0, t.useMemo)(function() {
      return { tracking: { dispatch: P(), getTrackingData: p(), process: h() || w } };
    }, [P, p, h, w]);
  }
})(br);
(function(e) {
  function t(w) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(h) {
      return typeof h;
    } : function(h) {
      return h && typeof Symbol == "function" && h.constructor === Symbol && h !== Symbol.prototype ? "symbol" : typeof h;
    }, t(w);
  }
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = S;
  var r = b(Ge), n = l(Ia), o = l(Fo), a = l(pt), s = l(br), i = ["forwardRef"], m = ["rtFwdRef"];
  function l(w) {
    return w && w.__esModule ? w : { default: w };
  }
  function f(w) {
    if (typeof WeakMap != "function")
      return null;
    var h = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ new WeakMap();
    return (f = function(P) {
      return P ? g : h;
    })(w);
  }
  function b(w, h) {
    if (!h && w && w.__esModule)
      return w;
    if (w === null || t(w) !== "object" && typeof w != "function")
      return { default: w };
    var g = f(h);
    if (g && g.has(w))
      return g.get(w);
    var p = {}, P = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var _ in w)
      if (_ !== "default" && Object.prototype.hasOwnProperty.call(w, _)) {
        var A = P ? Object.getOwnPropertyDescriptor(w, _) : null;
        A && (A.get || A.set) ? Object.defineProperty(p, _, A) : p[_] = w[_];
      }
    return p.default = w, g && g.set(w, p), p;
  }
  function c(w, h) {
    var g = Object.keys(w);
    if (Object.getOwnPropertySymbols) {
      var p = Object.getOwnPropertySymbols(w);
      h && (p = p.filter(function(P) {
        return Object.getOwnPropertyDescriptor(w, P).enumerable;
      })), g.push.apply(g, p);
    }
    return g;
  }
  function d(w) {
    for (var h = 1; h < arguments.length; h++) {
      var g = arguments[h] != null ? arguments[h] : {};
      h % 2 ? c(Object(g), !0).forEach(function(p) {
        v(w, p, g[p]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(w, Object.getOwnPropertyDescriptors(g)) : c(Object(g)).forEach(function(p) {
        Object.defineProperty(w, p, Object.getOwnPropertyDescriptor(g, p));
      });
    }
    return w;
  }
  function v(w, h, g) {
    return h in w ? Object.defineProperty(w, h, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : w[h] = g, w;
  }
  function u(w, h) {
    if (w == null)
      return {};
    var g = y(w, h), p, P;
    if (Object.getOwnPropertySymbols) {
      var _ = Object.getOwnPropertySymbols(w);
      for (P = 0; P < _.length; P++)
        p = _[P], !(h.indexOf(p) >= 0) && Object.prototype.propertyIsEnumerable.call(w, p) && (g[p] = w[p]);
    }
    return g;
  }
  function y(w, h) {
    if (w == null)
      return {};
    var g = {}, p = Object.keys(w), P, _;
    for (_ = 0; _ < p.length; _++)
      P = p[_], !(h.indexOf(P) >= 0) && (g[P] = w[P]);
    return g;
  }
  function S() {
    var w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, g = h.forwardRef, p = g === void 0 ? !1 : g, P = u(h, i);
    return function(_) {
      var A = _.displayName || _.name || "Component";
      function Y(X) {
        var J = X.rtFwdRef, H = u(X, m), Z = (0, r.useRef)(H);
        (0, r.useEffect)(function() {
          Z.current = H;
        });
        var K = (0, r.useCallback)(function() {
          return typeof w == "function" ? w(Z.current) : w;
        }, []), j = (0, s.default)(K, P), ue = (0, r.useMemo)(function() {
          return { trackEvent: j.tracking.dispatch, getTrackingData: j.tracking.getTrackingData };
        }, [j]), se = (0, r.useMemo)(function() {
          return p ? d(d({}, H), {}, { ref: J }) : H;
        }, [H, J]);
        return r.default.createElement(a.default.Provider, { value: j }, r.default.createElement(_, d(d({}, se), {}, { tracking: ue })));
      }
      if (p) {
        var q = r.default.forwardRef(function(X, J) {
          return r.default.createElement(Y, d(d({}, X), {}, { rtFwdRef: J }));
        });
        return q.displayName = "WithTracking(".concat(A, ")"), (0, n.default)(q, _), q;
      }
      return Y.displayName = "WithTracking(".concat(A, ")"), Y.propTypes = { rtFwdRef: o.default.oneOfType([o.default.func, o.default.shape({ current: o.default.any })]) }, Y.defaultProps = { rtFwdRef: void 0 }, (0, n.default)(Y, _), Y;
    };
  }
})(dr);
var hr = {}, Yo = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = t;
  function t(r) {
    return function(o, a, s) {
      var i = s.configurable, m = s.enumerable, l = s.value, f = s.get, b = s.initializer;
      if (l)
        return { configurable: i, enumerable: m, value: r(l) };
      if (f || b)
        return { configurable: i, enumerable: m, get: function() {
          if (this === o)
            return null;
          var d = b ? Reflect.apply(b, this, []) : Reflect.apply(f, this, []), v = r(d).bind(this);
          return Reflect.defineProperty(this, a, { configurable: i, enumerable: m, value: v }), v;
        } };
      throw new Error("called makeClassMemberDecorator on unsupported descriptor");
    };
  }
})(Yo);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = n;
  var t = r(Yo);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function n() {
    var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0, t.default)(function(a) {
      return function() {
        for (var i = this, m = arguments.length, l = new Array(m), f = 0; f < m; f++)
          l[f] = arguments[f];
        var b = function() {
          if (i.props && i.props.tracking && typeof i.props.tracking.trackEvent == "function") {
            for (var v = arguments.length, u = new Array(v), y = 0; y < v; y++)
              u[y] = arguments[y];
            var S = typeof o == "function" ? o(i.props, i.state, l, u) : o;
            S && i.props.tracking.trackEvent(S);
          }
        }, c = Reflect.apply(a, this, l);
        return Promise && Promise.resolve(c) === c ? c.then(b.bind(this)).then(function() {
          return c;
        }).catch(function(d) {
          throw b({}, d), d;
        }) : (b(), c);
      };
    });
  }
})(hr);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = o;
  var t = n(dr), r = n(hr);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function o(a, s) {
    return function() {
      return arguments.length === 1 ? (0, t.default)(a, s).apply(void 0, arguments) : (0, r.default)(a).apply(void 0, arguments);
    };
  }
})(Mo);
var Go = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
  var t = r(Fo);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var n = t.default.shape({ trackEvent: t.default.func, getTrackingData: t.default.func });
  e.default = n;
})(Go);
var Uo = {};
(function(e) {
  function t(l) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(f) {
      return typeof f;
    } : function(f) {
      return f && typeof Symbol == "function" && f.constructor === Symbol && f !== Symbol.prototype ? "symbol" : typeof f;
    }, t(l);
  }
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = m;
  var r = i(Ge), n = a(pt), o = a(br);
  function a(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function s(l) {
    if (typeof WeakMap != "function")
      return null;
    var f = /* @__PURE__ */ new WeakMap(), b = /* @__PURE__ */ new WeakMap();
    return (s = function(d) {
      return d ? b : f;
    })(l);
  }
  function i(l, f) {
    if (!f && l && l.__esModule)
      return l;
    if (l === null || t(l) !== "object" && typeof l != "function")
      return { default: l };
    var b = s(f);
    if (b && b.has(l))
      return b.get(l);
    var c = {}, d = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var v in l)
      if (v !== "default" && Object.prototype.hasOwnProperty.call(l, v)) {
        var u = d ? Object.getOwnPropertyDescriptor(l, v) : null;
        u && (u.get || u.set) ? Object.defineProperty(c, v, u) : c[v] = l[v];
      }
    return c.default = l, b && b.set(l, c), c;
  }
  function m(l, f) {
    var b = (0, o.default)(l, f), c = (0, r.useCallback)(function(d) {
      var v = d.children;
      return r.default.createElement(n.default.Provider, { value: b }, v);
    }, [b]);
    return (0, r.useDebugValue)(b.tracking.getTrackingData, function(d) {
      return d();
    }), (0, r.useMemo)(function() {
      return { Track: c, getTrackingData: b.tracking.getTrackingData, trackEvent: b.tracking.dispatch };
    }, [b, c]);
  }
})(Uo);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), Object.defineProperty(e, "TrackingPropType", { enumerable: !0, get: function() {
    return a.default;
  } }), Object.defineProperty(e, "deepmerge", { enumerable: !0, get: function() {
    return r.default;
  } }), e.default = void 0, Object.defineProperty(e, "track", { enumerable: !0, get: function() {
    return t.default;
  } }), Object.defineProperty(e, "trackEvent", { enumerable: !0, get: function() {
    return o.default;
  } }), Object.defineProperty(e, "useTracking", { enumerable: !0, get: function() {
    return s.default;
  } }), Object.defineProperty(e, "withTracking", { enumerable: !0, get: function() {
    return n.default;
  } });
  var t = i(Mo), r = i(Vo), n = i(dr), o = i(hr), a = i(Go), s = i(Uo);
  function i(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var m = t.default;
  e.default = m;
})(cr);
var tn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ri(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule"))
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var rn, nn;
function Ke() {
  return nn || (nn = 1, rn = TypeError), rn;
}
const ni = {}, oi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ni
}, Symbol.toStringTag, { value: "Module" })), ai = /* @__PURE__ */ ri(oi);
var Ct, on;
function dt() {
  if (on)
    return Ct;
  on = 1;
  var e = typeof Map == "function" && Map.prototype, t = Object.getOwnPropertyDescriptor && e ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, r = e && t && typeof t.get == "function" ? t.get : null, n = e && Map.prototype.forEach, o = typeof Set == "function" && Set.prototype, a = Object.getOwnPropertyDescriptor && o ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, s = o && a && typeof a.get == "function" ? a.get : null, i = o && Set.prototype.forEach, m = typeof WeakMap == "function" && WeakMap.prototype, l = m ? WeakMap.prototype.has : null, f = typeof WeakSet == "function" && WeakSet.prototype, b = f ? WeakSet.prototype.has : null, c = typeof WeakRef == "function" && WeakRef.prototype, d = c ? WeakRef.prototype.deref : null, v = Boolean.prototype.valueOf, u = Object.prototype.toString, y = Function.prototype.toString, S = String.prototype.match, w = String.prototype.slice, h = String.prototype.replace, g = String.prototype.toUpperCase, p = String.prototype.toLowerCase, P = RegExp.prototype.test, _ = Array.prototype.concat, A = Array.prototype.join, Y = Array.prototype.slice, q = Math.floor, X = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, J = Object.getOwnPropertySymbols, H = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, Z = typeof Symbol == "function" && typeof Symbol.iterator == "object", K = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === Z || !0) ? Symbol.toStringTag : null, j = Object.prototype.propertyIsEnumerable, ue = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(E) {
    return E.__proto__;
  } : null);
  function se(E, O) {
    if (E === 1 / 0 || E === -1 / 0 || E !== E || E && E > -1e3 && E < 1e3 || P.call(/e/, O))
      return O;
    var re = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof E == "number") {
      var fe = E < 0 ? -q(-E) : q(E);
      if (fe !== E) {
        var le = String(fe), B = w.call(O, le.length + 1);
        return h.call(le, re, "$&_") + "." + h.call(h.call(B, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return h.call(O, re, "$&_");
  }
  var ve = ai, T = ve.custom, C = $(T) ? T : null, F = {
    __proto__: null,
    double: '"',
    single: "'"
  }, M = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  Ct = function E(O, re, fe, le) {
    var B = re || {};
    if (me(B, "quoteStyle") && !me(F, B.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (me(B, "maxStringLength") && (typeof B.maxStringLength == "number" ? B.maxStringLength < 0 && B.maxStringLength !== 1 / 0 : B.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var Ne = me(B, "customInspect") ? B.customInspect : !0;
    if (typeof Ne != "boolean" && Ne !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (me(B, "indent") && B.indent !== null && B.indent !== "	" && !(parseInt(B.indent, 10) === B.indent && B.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (me(B, "numericSeparator") && typeof B.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var Ye = B.numericSeparator;
    if (typeof O > "u")
      return "undefined";
    if (O === null)
      return "null";
    if (typeof O == "boolean")
      return O ? "true" : "false";
    if (typeof O == "string")
      return Q(O, B);
    if (typeof O == "number") {
      if (O === 0)
        return 1 / 0 / O > 0 ? "0" : "-0";
      var Oe = String(O);
      return Ye ? se(O, Oe) : Oe;
    }
    if (typeof O == "bigint") {
      var Ve = String(O) + "n";
      return Ye ? se(O, Ve) : Ve;
    }
    var mt = typeof B.depth > "u" ? 5 : B.depth;
    if (typeof fe > "u" && (fe = 0), fe >= mt && mt > 0 && typeof O == "object")
      return D(O) ? "[Array]" : "[Object]";
    var Be = W(B, fe);
    if (typeof le > "u")
      le = [];
    else if (Me(le, O) >= 0)
      return "[Circular]";
    function Ae(ze, ut, ha) {
      if (ut && (le = Y.call(le), le.push(ut)), ha) {
        var Vr = {
          depth: B.depth
        };
        return me(B, "quoteStyle") && (Vr.quoteStyle = B.quoteStyle), E(ze, Vr, fe + 1, le);
      }
      return E(ze, B, fe + 1, le);
    }
    if (typeof O == "function" && !G(O)) {
      var Mr = ke(O), jr = Fe(O, Ae);
      return "[Function" + (Mr ? ": " + Mr : " (anonymous)") + "]" + (jr.length > 0 ? " { " + A.call(jr, ", ") + " }" : "");
    }
    if ($(O)) {
      var Ir = Z ? h.call(String(O), /^(Symbol\(.*\))_[^)]*$/, "$1") : H.call(O);
      return typeof O == "object" && !Z ? ee(Ir) : Ir;
    }
    if (z(O)) {
      for (var et = "<" + p.call(String(O.nodeName)), bt = O.attributes || [], ct = 0; ct < bt.length; ct++)
        et += " " + bt[ct].name + "=" + L(V(bt[ct].value), "double", B);
      return et += ">", O.childNodes && O.childNodes.length && (et += "..."), et += "</" + p.call(String(O.nodeName)) + ">", et;
    }
    if (D(O)) {
      if (O.length === 0)
        return "[]";
      var ht = Fe(O, Ae);
      return Be && !te(ht) ? "[" + Ee(ht, Be) + "]" : "[ " + A.call(ht, ", ") + " ]";
    }
    if (x(O)) {
      var gt = Fe(O, Ae);
      return !("cause" in Error.prototype) && "cause" in O && !j.call(O, "cause") ? "{ [" + String(O) + "] " + A.call(_.call("[cause]: " + Ae(O.cause), gt), ", ") + " }" : gt.length === 0 ? "[" + String(O) + "]" : "{ [" + String(O) + "] " + A.call(gt, ", ") + " }";
    }
    if (typeof O == "object" && Ne) {
      if (C && typeof O[C] == "function" && ve)
        return ve(O, { depth: mt - fe });
      if (Ne !== "symbol" && typeof O.inspect == "function")
        return O.inspect();
    }
    if (we(O)) {
      var Lr = [];
      return n && n.call(O, function(ze, ut) {
        Lr.push(Ae(ut, O, !0) + " => " + Ae(ze, O));
      }), Re("Map", r.call(O), Lr, Be);
    }
    if (Se(O)) {
      var Dr = [];
      return i && i.call(O, function(ze) {
        Dr.push(Ae(ze, O));
      }), Re("Set", s.call(O), Dr, Be);
    }
    if (je(O))
      return Te("WeakMap");
    if (Ue(O))
      return Te("WeakSet");
    if (he(O))
      return Te("WeakRef");
    if (N(O))
      return ee(Ae(Number(O)));
    if (pe(O))
      return ee(Ae(X.call(O)));
    if (R(O))
      return ee(v.call(O));
    if (k(O))
      return ee(Ae(String(O)));
    if (typeof window < "u" && O === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && O === globalThis || typeof tn < "u" && O === tn)
      return "{ [object globalThis] }";
    if (!I(O) && !G(O)) {
      var wt = Fe(O, Ae), Fr = ue ? ue(O) === Object.prototype : O instanceof Object || O.constructor === Object, Et = O instanceof Object ? "" : "null prototype", Nr = !Fr && K && Object(O) === O && K in O ? w.call(be(O), 8, -1) : Et ? "Object" : "", ba = Fr || typeof O.constructor != "function" ? "" : O.constructor.name ? O.constructor.name + " " : "", St = ba + (Nr || Et ? "[" + A.call(_.call([], Nr || [], Et || []), ": ") + "] " : "");
      return wt.length === 0 ? St + "{}" : Be ? St + "{" + Ee(wt, Be) + "}" : St + "{ " + A.call(wt, ", ") + " }";
    }
    return String(O);
  };
  function L(E, O, re) {
    var fe = re.quoteStyle || O, le = F[fe];
    return le + E + le;
  }
  function V(E) {
    return h.call(String(E), /"/g, "&quot;");
  }
  function D(E) {
    return be(E) === "[object Array]" && (!K || !(typeof E == "object" && K in E));
  }
  function I(E) {
    return be(E) === "[object Date]" && (!K || !(typeof E == "object" && K in E));
  }
  function G(E) {
    return be(E) === "[object RegExp]" && (!K || !(typeof E == "object" && K in E));
  }
  function x(E) {
    return be(E) === "[object Error]" && (!K || !(typeof E == "object" && K in E));
  }
  function k(E) {
    return be(E) === "[object String]" && (!K || !(typeof E == "object" && K in E));
  }
  function N(E) {
    return be(E) === "[object Number]" && (!K || !(typeof E == "object" && K in E));
  }
  function R(E) {
    return be(E) === "[object Boolean]" && (!K || !(typeof E == "object" && K in E));
  }
  function $(E) {
    if (Z)
      return E && typeof E == "object" && E instanceof Symbol;
    if (typeof E == "symbol")
      return !0;
    if (!E || typeof E != "object" || !H)
      return !1;
    try {
      return H.call(E), !0;
    } catch {
    }
    return !1;
  }
  function pe(E) {
    if (!E || typeof E != "object" || !X)
      return !1;
    try {
      return X.call(E), !0;
    } catch {
    }
    return !1;
  }
  var de = Object.prototype.hasOwnProperty || function(E) {
    return E in this;
  };
  function me(E, O) {
    return de.call(E, O);
  }
  function be(E) {
    return u.call(E);
  }
  function ke(E) {
    if (E.name)
      return E.name;
    var O = S.call(y.call(E), /^function\s*([\w$]+)/);
    return O ? O[1] : null;
  }
  function Me(E, O) {
    if (E.indexOf)
      return E.indexOf(O);
    for (var re = 0, fe = E.length; re < fe; re++)
      if (E[re] === O)
        return re;
    return -1;
  }
  function we(E) {
    if (!r || !E || typeof E != "object")
      return !1;
    try {
      r.call(E);
      try {
        s.call(E);
      } catch {
        return !0;
      }
      return E instanceof Map;
    } catch {
    }
    return !1;
  }
  function je(E) {
    if (!l || !E || typeof E != "object")
      return !1;
    try {
      l.call(E, l);
      try {
        b.call(E, b);
      } catch {
        return !0;
      }
      return E instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function he(E) {
    if (!d || !E || typeof E != "object")
      return !1;
    try {
      return d.call(E), !0;
    } catch {
    }
    return !1;
  }
  function Se(E) {
    if (!s || !E || typeof E != "object")
      return !1;
    try {
      s.call(E);
      try {
        r.call(E);
      } catch {
        return !0;
      }
      return E instanceof Set;
    } catch {
    }
    return !1;
  }
  function Ue(E) {
    if (!b || !E || typeof E != "object")
      return !1;
    try {
      b.call(E, b);
      try {
        l.call(E, l);
      } catch {
        return !0;
      }
      return E instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function z(E) {
    return !E || typeof E != "object" ? !1 : typeof HTMLElement < "u" && E instanceof HTMLElement ? !0 : typeof E.nodeName == "string" && typeof E.getAttribute == "function";
  }
  function Q(E, O) {
    if (E.length > O.maxStringLength) {
      var re = E.length - O.maxStringLength, fe = "... " + re + " more character" + (re > 1 ? "s" : "");
      return Q(w.call(E, 0, O.maxStringLength), O) + fe;
    }
    var le = M[O.quoteStyle || "single"];
    le.lastIndex = 0;
    var B = h.call(h.call(E, le, "\\$1"), /[\x00-\x1f]/g, U);
    return L(B, "single", O);
  }
  function U(E) {
    var O = E.charCodeAt(0), re = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[O];
    return re ? "\\" + re : "\\x" + (O < 16 ? "0" : "") + g.call(O.toString(16));
  }
  function ee(E) {
    return "Object(" + E + ")";
  }
  function Te(E) {
    return E + " { ? }";
  }
  function Re(E, O, re, fe) {
    var le = fe ? Ee(re, fe) : A.call(re, ", ");
    return E + " (" + O + ") {" + le + "}";
  }
  function te(E) {
    for (var O = 0; O < E.length; O++)
      if (Me(E[O], `
`) >= 0)
        return !1;
    return !0;
  }
  function W(E, O) {
    var re;
    if (E.indent === "	")
      re = "	";
    else if (typeof E.indent == "number" && E.indent > 0)
      re = A.call(Array(E.indent + 1), " ");
    else
      return null;
    return {
      base: re,
      prev: A.call(Array(O + 1), re)
    };
  }
  function Ee(E, O) {
    if (E.length === 0)
      return "";
    var re = `
` + O.prev + O.base;
    return re + A.call(E, "," + re) + `
` + O.prev;
  }
  function Fe(E, O) {
    var re = D(E), fe = [];
    if (re) {
      fe.length = E.length;
      for (var le = 0; le < E.length; le++)
        fe[le] = me(E, le) ? O(E[le], E) : "";
    }
    var B = typeof J == "function" ? J(E) : [], Ne;
    if (Z) {
      Ne = {};
      for (var Ye = 0; Ye < B.length; Ye++)
        Ne["$" + B[Ye]] = B[Ye];
    }
    for (var Oe in E)
      me(E, Oe) && (re && String(Number(Oe)) === Oe && Oe < E.length || Z && Ne["$" + Oe] instanceof Symbol || (P.call(/[^\w$]/, Oe) ? fe.push(O(Oe, E) + ": " + O(E[Oe], E)) : fe.push(Oe + ": " + O(E[Oe], E))));
    if (typeof J == "function")
      for (var Ve = 0; Ve < B.length; Ve++)
        j.call(E, B[Ve]) && fe.push("[" + O(B[Ve]) + "]: " + O(E[B[Ve]], E));
    return fe;
  }
  return Ct;
}
var xt, an;
function ii() {
  if (an)
    return xt;
  an = 1;
  var e = /* @__PURE__ */ dt(), t = /* @__PURE__ */ Ke(), r = function(i, m, l) {
    for (var f = i, b; (b = f.next) != null; f = b)
      if (b.key === m)
        return f.next = b.next, l || (b.next = /** @type {NonNullable<typeof list.next>} */
        i.next, i.next = b), b;
  }, n = function(i, m) {
    if (i) {
      var l = r(i, m);
      return l && l.value;
    }
  }, o = function(i, m, l) {
    var f = r(i, m);
    f ? f.value = l : i.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: m,
      next: i.next,
      value: l
    };
  }, a = function(i, m) {
    return i ? !!r(i, m) : !1;
  }, s = function(i, m) {
    if (i)
      return r(i, m, !0);
  };
  return xt = function() {
    var i, m = {
      assert: function(l) {
        if (!m.has(l))
          throw new t("Side channel does not contain " + e(l));
      },
      delete: function(l) {
        var f = i && i.next, b = s(i, l);
        return b && f && f === b && (i = void 0), !!b;
      },
      get: function(l) {
        return n(i, l);
      },
      has: function(l) {
        return a(i, l);
      },
      set: function(l, f) {
        i || (i = {
          next: void 0
        }), o(
          /** @type {NonNullable<typeof $o>} */
          i,
          l,
          f
        );
      }
    };
    return m;
  }, xt;
}
var cn, un;
function Bo() {
  return un || (un = 1, cn = Object), cn;
}
var sn, fn;
function ci() {
  return fn || (fn = 1, sn = Error), sn;
}
var ln, pn;
function ui() {
  return pn || (pn = 1, ln = EvalError), ln;
}
var dn, yn;
function si() {
  return yn || (yn = 1, dn = RangeError), dn;
}
var vn, mn;
function fi() {
  return mn || (mn = 1, vn = ReferenceError), vn;
}
var bn, hn;
function li() {
  return hn || (hn = 1, bn = SyntaxError), bn;
}
var gn, wn;
function pi() {
  return wn || (wn = 1, gn = URIError), gn;
}
var En, Sn;
function di() {
  return Sn || (Sn = 1, En = Math.abs), En;
}
var Rn, On;
function yi() {
  return On || (On = 1, Rn = Math.floor), Rn;
}
var _n, Tn;
function vi() {
  return Tn || (Tn = 1, _n = Math.max), _n;
}
var Pn, An;
function mi() {
  return An || (An = 1, Pn = Math.min), Pn;
}
var Cn, xn;
function bi() {
  return xn || (xn = 1, Cn = Math.pow), Cn;
}
var kn, Mn;
function hi() {
  return Mn || (Mn = 1, kn = Math.round), kn;
}
var jn, In;
function gi() {
  return In || (In = 1, jn = Number.isNaN || function(e) {
    return e !== e;
  }), jn;
}
var kt, Ln;
function wi() {
  if (Ln)
    return kt;
  Ln = 1;
  var e = /* @__PURE__ */ gi();
  return kt = function(t) {
    return e(t) || t === 0 ? t : t < 0 ? -1 : 1;
  }, kt;
}
var Dn, Fn;
function Ei() {
  return Fn || (Fn = 1, Dn = Object.getOwnPropertyDescriptor), Dn;
}
var Mt, Nn;
function zo() {
  if (Nn)
    return Mt;
  Nn = 1;
  var e = /* @__PURE__ */ Ei();
  if (e)
    try {
      e([], "length");
    } catch {
      e = null;
    }
  return Mt = e, Mt;
}
var jt, Vn;
function Si() {
  if (Vn)
    return jt;
  Vn = 1;
  var e = Object.defineProperty || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return jt = e, jt;
}
var Wn, Yn;
function Ri() {
  return Yn || (Yn = 1, Wn = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var e = {}, t = Symbol("test"), r = Object(t);
    if (typeof t == "string" || Object.prototype.toString.call(t) !== "[object Symbol]" || Object.prototype.toString.call(r) !== "[object Symbol]")
      return !1;
    var n = 42;
    e[t] = n;
    for (var o in e)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
      return !1;
    var a = Object.getOwnPropertySymbols(e);
    if (a.length !== 1 || a[0] !== t || !Object.prototype.propertyIsEnumerable.call(e, t))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var s = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(e, t)
      );
      if (s.value !== n || s.enumerable !== !0)
        return !1;
    }
    return !0;
  }), Wn;
}
var It, Gn;
function Oi() {
  if (Gn)
    return It;
  Gn = 1;
  var e = typeof Symbol < "u" && Symbol, t = Ri();
  return It = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, It;
}
var Un, Bn;
function Zo() {
  return Bn || (Bn = 1, Un = typeof Reflect < "u" && Reflect.getPrototypeOf || null), Un;
}
var Lt, zn;
function qo() {
  if (zn)
    return Lt;
  zn = 1;
  var e = /* @__PURE__ */ Bo();
  return Lt = e.getPrototypeOf || null, Lt;
}
var Dt, Zn;
function _i() {
  if (Zn)
    return Dt;
  Zn = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, r = Math.max, n = "[object Function]", o = function(i, m) {
    for (var l = [], f = 0; f < i.length; f += 1)
      l[f] = i[f];
    for (var b = 0; b < m.length; b += 1)
      l[b + i.length] = m[b];
    return l;
  }, a = function(i, m) {
    for (var l = [], f = m, b = 0; f < i.length; f += 1, b += 1)
      l[b] = i[f];
    return l;
  }, s = function(i, m) {
    for (var l = "", f = 0; f < i.length; f += 1)
      l += i[f], f + 1 < i.length && (l += m);
    return l;
  };
  return Dt = function(i) {
    var m = this;
    if (typeof m != "function" || t.apply(m) !== n)
      throw new TypeError(e + m);
    for (var l = a(arguments, 1), f, b = function() {
      if (this instanceof f) {
        var y = m.apply(
          this,
          o(l, arguments)
        );
        return Object(y) === y ? y : this;
      }
      return m.apply(
        i,
        o(l, arguments)
      );
    }, c = r(0, m.length - l.length), d = [], v = 0; v < c; v++)
      d[v] = "$" + v;
    if (f = Function("binder", "return function (" + s(d, ",") + "){ return binder.apply(this,arguments); }")(b), m.prototype) {
      var u = function() {
      };
      u.prototype = m.prototype, f.prototype = new u(), u.prototype = null;
    }
    return f;
  }, Dt;
}
var Ft, qn;
function yt() {
  if (qn)
    return Ft;
  qn = 1;
  var e = _i();
  return Ft = Function.prototype.bind || e, Ft;
}
var Hn, $n;
function gr() {
  return $n || ($n = 1, Hn = Function.prototype.call), Hn;
}
var Xn, Jn;
function Ho() {
  return Jn || (Jn = 1, Xn = Function.prototype.apply), Xn;
}
var Kn, Qn;
function Ti() {
  return Qn || (Qn = 1, Kn = typeof Reflect < "u" && Reflect && Reflect.apply), Kn;
}
var Nt, eo;
function Pi() {
  if (eo)
    return Nt;
  eo = 1;
  var e = yt(), t = Ho(), r = gr(), n = Ti();
  return Nt = n || e.call(r, t), Nt;
}
var Vt, to;
function $o() {
  if (to)
    return Vt;
  to = 1;
  var e = yt(), t = /* @__PURE__ */ Ke(), r = gr(), n = Pi();
  return Vt = function(o) {
    if (o.length < 1 || typeof o[0] != "function")
      throw new t("a function is required");
    return n(e, r, o);
  }, Vt;
}
var Wt, ro;
function Ai() {
  if (ro)
    return Wt;
  ro = 1;
  var e = $o(), t = /* @__PURE__ */ zo(), r;
  try {
    r = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (s) {
    if (!s || typeof s != "object" || !("code" in s) || s.code !== "ERR_PROTO_ACCESS")
      throw s;
  }
  var n = !!r && t && t(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), o = Object, a = o.getPrototypeOf;
  return Wt = n && typeof n.get == "function" ? e([n.get]) : typeof a == "function" ? (
    /** @type {import('./get')} */
    function(s) {
      return a(s == null ? s : o(s));
    }
  ) : !1, Wt;
}
var Yt, no;
function Ci() {
  if (no)
    return Yt;
  no = 1;
  var e = Zo(), t = qo(), r = /* @__PURE__ */ Ai();
  return Yt = e ? function(n) {
    return e(n);
  } : t ? function(n) {
    if (!n || typeof n != "object" && typeof n != "function")
      throw new TypeError("getProto: not an object");
    return t(n);
  } : r ? function(n) {
    return r(n);
  } : null, Yt;
}
var Gt, oo;
function xi() {
  if (oo)
    return Gt;
  oo = 1;
  var e = Function.prototype.call, t = Object.prototype.hasOwnProperty, r = yt();
  return Gt = r.call(e, t), Gt;
}
var Ut, ao;
function wr() {
  if (ao)
    return Ut;
  ao = 1;
  var e, t = /* @__PURE__ */ Bo(), r = /* @__PURE__ */ ci(), n = /* @__PURE__ */ ui(), o = /* @__PURE__ */ si(), a = /* @__PURE__ */ fi(), s = /* @__PURE__ */ li(), i = /* @__PURE__ */ Ke(), m = /* @__PURE__ */ pi(), l = /* @__PURE__ */ di(), f = /* @__PURE__ */ yi(), b = /* @__PURE__ */ vi(), c = /* @__PURE__ */ mi(), d = /* @__PURE__ */ bi(), v = /* @__PURE__ */ hi(), u = /* @__PURE__ */ wi(), y = Function, S = function(x) {
    try {
      return y('"use strict"; return (' + x + ").constructor;")();
    } catch {
    }
  }, w = /* @__PURE__ */ zo(), h = /* @__PURE__ */ Si(), g = function() {
    throw new i();
  }, p = w ? function() {
    try {
      return arguments.callee, g;
    } catch {
      try {
        return w(arguments, "callee").get;
      } catch {
        return g;
      }
    }
  }() : g, P = Oi()(), _ = Ci(), A = qo(), Y = Zo(), q = Ho(), X = gr(), J = {}, H = typeof Uint8Array > "u" || !_ ? e : _(Uint8Array), Z = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? e : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? e : ArrayBuffer,
    "%ArrayIteratorPrototype%": P && _ ? _([][Symbol.iterator]()) : e,
    "%AsyncFromSyncIteratorPrototype%": e,
    "%AsyncFunction%": J,
    "%AsyncGenerator%": J,
    "%AsyncGeneratorFunction%": J,
    "%AsyncIteratorPrototype%": J,
    "%Atomics%": typeof Atomics > "u" ? e : Atomics,
    "%BigInt%": typeof BigInt > "u" ? e : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? e : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? e : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? e : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": r,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": n,
    "%Float32Array%": typeof Float32Array > "u" ? e : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? e : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? e : FinalizationRegistry,
    "%Function%": y,
    "%GeneratorFunction%": J,
    "%Int8Array%": typeof Int8Array > "u" ? e : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? e : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? e : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": P && _ ? _(_([][Symbol.iterator]())) : e,
    "%JSON%": typeof JSON == "object" ? JSON : e,
    "%Map%": typeof Map > "u" ? e : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !P || !_ ? e : _((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": t,
    "%Object.getOwnPropertyDescriptor%": w,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? e : Promise,
    "%Proxy%": typeof Proxy > "u" ? e : Proxy,
    "%RangeError%": o,
    "%ReferenceError%": a,
    "%Reflect%": typeof Reflect > "u" ? e : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? e : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !P || !_ ? e : _((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? e : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": P && _ ? _(""[Symbol.iterator]()) : e,
    "%Symbol%": P ? Symbol : e,
    "%SyntaxError%": s,
    "%ThrowTypeError%": p,
    "%TypedArray%": H,
    "%TypeError%": i,
    "%Uint8Array%": typeof Uint8Array > "u" ? e : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? e : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? e : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? e : Uint32Array,
    "%URIError%": m,
    "%WeakMap%": typeof WeakMap > "u" ? e : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? e : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? e : WeakSet,
    "%Function.prototype.call%": X,
    "%Function.prototype.apply%": q,
    "%Object.defineProperty%": h,
    "%Object.getPrototypeOf%": A,
    "%Math.abs%": l,
    "%Math.floor%": f,
    "%Math.max%": b,
    "%Math.min%": c,
    "%Math.pow%": d,
    "%Math.round%": v,
    "%Math.sign%": u,
    "%Reflect.getPrototypeOf%": Y
  };
  if (_)
    try {
      null.error;
    } catch (x) {
      var K = _(_(x));
      Z["%Error.prototype%"] = K;
    }
  var j = function x(k) {
    var N;
    if (k === "%AsyncFunction%")
      N = S("async function () {}");
    else if (k === "%GeneratorFunction%")
      N = S("function* () {}");
    else if (k === "%AsyncGeneratorFunction%")
      N = S("async function* () {}");
    else if (k === "%AsyncGenerator%") {
      var R = x("%AsyncGeneratorFunction%");
      R && (N = R.prototype);
    } else if (k === "%AsyncIteratorPrototype%") {
      var $ = x("%AsyncGenerator%");
      $ && _ && (N = _($.prototype));
    }
    return Z[k] = N, N;
  }, ue = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, se = yt(), ve = /* @__PURE__ */ xi(), T = se.call(X, Array.prototype.concat), C = se.call(q, Array.prototype.splice), F = se.call(X, String.prototype.replace), M = se.call(X, String.prototype.slice), L = se.call(X, RegExp.prototype.exec), V = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, D = /\\(\\)?/g, I = function(x) {
    var k = M(x, 0, 1), N = M(x, -1);
    if (k === "%" && N !== "%")
      throw new s("invalid intrinsic syntax, expected closing `%`");
    if (N === "%" && k !== "%")
      throw new s("invalid intrinsic syntax, expected opening `%`");
    var R = [];
    return F(x, V, function($, pe, de, me) {
      R[R.length] = de ? F(me, D, "$1") : pe || $;
    }), R;
  }, G = function(x, k) {
    var N = x, R;
    if (ve(ue, N) && (R = ue[N], N = "%" + R[0] + "%"), ve(Z, N)) {
      var $ = Z[N];
      if ($ === J && ($ = j(N)), typeof $ > "u" && !k)
        throw new i("intrinsic " + x + " exists, but is not available. Please file an issue!");
      return {
        alias: R,
        name: N,
        value: $
      };
    }
    throw new s("intrinsic " + x + " does not exist!");
  };
  return Ut = function(x, k) {
    if (typeof x != "string" || x.length === 0)
      throw new i("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof k != "boolean")
      throw new i('"allowMissing" argument must be a boolean');
    if (L(/^%?[^%]*%?$/, x) === null)
      throw new s("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var N = I(x), R = N.length > 0 ? N[0] : "", $ = G("%" + R + "%", k), pe = $.name, de = $.value, me = !1, be = $.alias;
    be && (R = be[0], C(N, T([0, 1], be)));
    for (var ke = 1, Me = !0; ke < N.length; ke += 1) {
      var we = N[ke], je = M(we, 0, 1), he = M(we, -1);
      if ((je === '"' || je === "'" || je === "`" || he === '"' || he === "'" || he === "`") && je !== he)
        throw new s("property names with quotes must have matching quotes");
      if ((we === "constructor" || !Me) && (me = !0), R += "." + we, pe = "%" + R + "%", ve(Z, pe))
        de = Z[pe];
      else if (de != null) {
        if (!(we in de)) {
          if (!k)
            throw new i("base intrinsic for " + x + " exists, but the property is not available.");
          return;
        }
        if (w && ke + 1 >= N.length) {
          var Se = w(de, we);
          Me = !!Se, Me && "get" in Se && !("originalValue" in Se.get) ? de = Se.get : de = de[we];
        } else
          Me = ve(de, we), de = de[we];
        Me && !me && (Z[pe] = de);
      }
    }
    return de;
  }, Ut;
}
var Bt, io;
function Xo() {
  if (io)
    return Bt;
  io = 1;
  var e = /* @__PURE__ */ wr(), t = $o(), r = t([e("%String.prototype.indexOf%")]);
  return Bt = function(n, o) {
    var a = (
      /** @type {Parameters<typeof callBindBasic>[0][0]} */
      e(n, !!o)
    );
    return typeof a == "function" && r(n, ".prototype.") > -1 ? t([a]) : a;
  }, Bt;
}
var zt, co;
function Jo() {
  if (co)
    return zt;
  co = 1;
  var e = /* @__PURE__ */ wr(), t = /* @__PURE__ */ Xo(), r = /* @__PURE__ */ dt(), n = /* @__PURE__ */ Ke(), o = e("%Map%", !0), a = t("Map.prototype.get", !0), s = t("Map.prototype.set", !0), i = t("Map.prototype.has", !0), m = t("Map.prototype.delete", !0), l = t("Map.prototype.size", !0);
  return zt = !!o && /** @type {Exclude<import('.'), false>} */
  function() {
    var f, b = {
      assert: function(c) {
        if (!b.has(c))
          throw new n("Side channel does not contain " + r(c));
      },
      delete: function(c) {
        if (f) {
          var d = m(f, c);
          return l(f) === 0 && (f = void 0), d;
        }
        return !1;
      },
      get: function(c) {
        if (f)
          return a(f, c);
      },
      has: function(c) {
        return f ? i(f, c) : !1;
      },
      set: function(c, d) {
        f || (f = new o()), s(f, c, d);
      }
    };
    return b;
  }, zt;
}
var Zt, uo;
function ki() {
  if (uo)
    return Zt;
  uo = 1;
  var e = /* @__PURE__ */ wr(), t = /* @__PURE__ */ Xo(), r = /* @__PURE__ */ dt(), n = Jo(), o = /* @__PURE__ */ Ke(), a = e("%WeakMap%", !0), s = t("WeakMap.prototype.get", !0), i = t("WeakMap.prototype.set", !0), m = t("WeakMap.prototype.has", !0), l = t("WeakMap.prototype.delete", !0);
  return Zt = a ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var f, b, c = {
        assert: function(d) {
          if (!c.has(d))
            throw new o("Side channel does not contain " + r(d));
        },
        delete: function(d) {
          if (a && d && (typeof d == "object" || typeof d == "function")) {
            if (f)
              return l(f, d);
          } else if (n && b)
            return b.delete(d);
          return !1;
        },
        get: function(d) {
          return a && d && (typeof d == "object" || typeof d == "function") && f ? s(f, d) : b && b.get(d);
        },
        has: function(d) {
          return a && d && (typeof d == "object" || typeof d == "function") && f ? m(f, d) : !!b && b.has(d);
        },
        set: function(d, v) {
          a && d && (typeof d == "object" || typeof d == "function") ? (f || (f = new a()), i(f, d, v)) : n && (b || (b = n()), b.set(d, v));
        }
      };
      return c;
    }
  ) : n, Zt;
}
var qt, so;
function Mi() {
  if (so)
    return qt;
  so = 1;
  var e = /* @__PURE__ */ Ke(), t = /* @__PURE__ */ dt(), r = ii(), n = Jo(), o = ki(), a = o || n || r;
  return qt = function() {
    var s, i = {
      assert: function(m) {
        if (!i.has(m))
          throw new e("Side channel does not contain " + t(m));
      },
      delete: function(m) {
        return !!s && s.delete(m);
      },
      get: function(m) {
        return s && s.get(m);
      },
      has: function(m) {
        return !!s && s.has(m);
      },
      set: function(m, l) {
        s || (s = a()), s.set(m, l);
      }
    };
    return i;
  }, qt;
}
var Ht, fo;
function Er() {
  if (fo)
    return Ht;
  fo = 1;
  var e = String.prototype.replace, t = /%20/g, r = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return Ht = {
    default: r.RFC3986,
    formatters: {
      RFC1738: function(n) {
        return e.call(n, t, "+");
      },
      RFC3986: function(n) {
        return String(n);
      }
    },
    RFC1738: r.RFC1738,
    RFC3986: r.RFC3986
  }, Ht;
}
var $t, lo;
function Ko() {
  if (lo)
    return $t;
  lo = 1;
  var e = Er(), t = Object.prototype.hasOwnProperty, r = Array.isArray, n = function() {
    for (var u = [], y = 0; y < 256; ++y)
      u.push("%" + ((y < 16 ? "0" : "") + y.toString(16)).toUpperCase());
    return u;
  }(), o = function(u) {
    for (; u.length > 1; ) {
      var y = u.pop(), S = y.obj[y.prop];
      if (r(S)) {
        for (var w = [], h = 0; h < S.length; ++h)
          typeof S[h] < "u" && w.push(S[h]);
        y.obj[y.prop] = w;
      }
    }
  }, a = function(u, y) {
    for (var S = y && y.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, w = 0; w < u.length; ++w)
      typeof u[w] < "u" && (S[w] = u[w]);
    return S;
  }, s = function u(y, S, w) {
    if (!S)
      return y;
    if (typeof S != "object") {
      if (r(y))
        y.push(S);
      else if (y && typeof y == "object")
        (w && (w.plainObjects || w.allowPrototypes) || !t.call(Object.prototype, S)) && (y[S] = !0);
      else
        return [y, S];
      return y;
    }
    if (!y || typeof y != "object")
      return [y].concat(S);
    var h = y;
    return r(y) && !r(S) && (h = a(y, w)), r(y) && r(S) ? (S.forEach(function(g, p) {
      if (t.call(y, p)) {
        var P = y[p];
        P && typeof P == "object" && g && typeof g == "object" ? y[p] = u(P, g, w) : y.push(g);
      } else
        y[p] = g;
    }), y) : Object.keys(S).reduce(function(g, p) {
      var P = S[p];
      return t.call(g, p) ? g[p] = u(g[p], P, w) : g[p] = P, g;
    }, h);
  }, i = function(u, y) {
    return Object.keys(y).reduce(function(S, w) {
      return S[w] = y[w], S;
    }, u);
  }, m = function(u, y, S) {
    var w = u.replace(/\+/g, " ");
    if (S === "iso-8859-1")
      return w.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(w);
    } catch {
      return w;
    }
  }, l = function(u, y, S, w, h) {
    if (u.length === 0)
      return u;
    var g = u;
    if (typeof u == "symbol" ? g = Symbol.prototype.toString.call(u) : typeof u != "string" && (g = String(u)), S === "iso-8859-1")
      return escape(g).replace(/%u[0-9a-f]{4}/gi, function(A) {
        return "%26%23" + parseInt(A.slice(2), 16) + "%3B";
      });
    for (var p = "", P = 0; P < g.length; ++P) {
      var _ = g.charCodeAt(P);
      if (_ === 45 || _ === 46 || _ === 95 || _ === 126 || _ >= 48 && _ <= 57 || _ >= 65 && _ <= 90 || _ >= 97 && _ <= 122 || h === e.RFC1738 && (_ === 40 || _ === 41)) {
        p += g.charAt(P);
        continue;
      }
      if (_ < 128) {
        p = p + n[_];
        continue;
      }
      if (_ < 2048) {
        p = p + (n[192 | _ >> 6] + n[128 | _ & 63]);
        continue;
      }
      if (_ < 55296 || _ >= 57344) {
        p = p + (n[224 | _ >> 12] + n[128 | _ >> 6 & 63] + n[128 | _ & 63]);
        continue;
      }
      P += 1, _ = 65536 + ((_ & 1023) << 10 | g.charCodeAt(P) & 1023), p += n[240 | _ >> 18] + n[128 | _ >> 12 & 63] + n[128 | _ >> 6 & 63] + n[128 | _ & 63];
    }
    return p;
  }, f = function(u) {
    for (var y = [{ obj: { o: u }, prop: "o" }], S = [], w = 0; w < y.length; ++w)
      for (var h = y[w], g = h.obj[h.prop], p = Object.keys(g), P = 0; P < p.length; ++P) {
        var _ = p[P], A = g[_];
        typeof A == "object" && A !== null && S.indexOf(A) === -1 && (y.push({ obj: g, prop: _ }), S.push(A));
      }
    return o(y), u;
  }, b = function(u) {
    return Object.prototype.toString.call(u) === "[object RegExp]";
  }, c = function(u) {
    return !u || typeof u != "object" ? !1 : !!(u.constructor && u.constructor.isBuffer && u.constructor.isBuffer(u));
  }, d = function(u, y) {
    return [].concat(u, y);
  }, v = function(u, y) {
    if (r(u)) {
      for (var S = [], w = 0; w < u.length; w += 1)
        S.push(y(u[w]));
      return S;
    }
    return y(u);
  };
  return $t = {
    arrayToObject: a,
    assign: i,
    combine: d,
    compact: f,
    decode: m,
    encode: l,
    isBuffer: c,
    isRegExp: b,
    maybeMap: v,
    merge: s
  }, $t;
}
var Xt, po;
function ji() {
  if (po)
    return Xt;
  po = 1;
  var e = Mi(), t = Ko(), r = Er(), n = Object.prototype.hasOwnProperty, o = {
    brackets: function(u) {
      return u + "[]";
    },
    comma: "comma",
    indices: function(u, y) {
      return u + "[" + y + "]";
    },
    repeat: function(u) {
      return u;
    }
  }, a = Array.isArray, s = Array.prototype.push, i = function(u, y) {
    s.apply(u, a(y) ? y : [y]);
  }, m = Date.prototype.toISOString, l = r.default, f = {
    addQueryPrefix: !1,
    allowDots: !1,
    charset: "utf-8",
    charsetSentinel: !1,
    delimiter: "&",
    encode: !0,
    encoder: t.encode,
    encodeValuesOnly: !1,
    format: l,
    formatter: r.formatters[l],
    // deprecated
    indices: !1,
    serializeDate: function(u) {
      return m.call(u);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, b = function(u) {
    return typeof u == "string" || typeof u == "number" || typeof u == "boolean" || typeof u == "symbol" || typeof u == "bigint";
  }, c = {}, d = function u(y, S, w, h, g, p, P, _, A, Y, q, X, J, H, Z, K) {
    for (var j = y, ue = K, se = 0, ve = !1; (ue = ue.get(c)) !== void 0 && !ve; ) {
      var T = ue.get(y);
      if (se += 1, typeof T < "u") {
        if (T === se)
          throw new RangeError("Cyclic object value");
        ve = !0;
      }
      typeof ue.get(c) > "u" && (se = 0);
    }
    if (typeof _ == "function" ? j = _(S, j) : j instanceof Date ? j = q(j) : w === "comma" && a(j) && (j = t.maybeMap(j, function(N) {
      return N instanceof Date ? q(N) : N;
    })), j === null) {
      if (g)
        return P && !H ? P(S, f.encoder, Z, "key", X) : S;
      j = "";
    }
    if (b(j) || t.isBuffer(j)) {
      if (P) {
        var C = H ? S : P(S, f.encoder, Z, "key", X);
        return [J(C) + "=" + J(P(j, f.encoder, Z, "value", X))];
      }
      return [J(S) + "=" + J(String(j))];
    }
    var F = [];
    if (typeof j > "u")
      return F;
    var M;
    if (w === "comma" && a(j))
      H && P && (j = t.maybeMap(j, P)), M = [{ value: j.length > 0 ? j.join(",") || null : void 0 }];
    else if (a(_))
      M = _;
    else {
      var L = Object.keys(j);
      M = A ? L.sort(A) : L;
    }
    for (var V = h && a(j) && j.length === 1 ? S + "[]" : S, D = 0; D < M.length; ++D) {
      var I = M[D], G = typeof I == "object" && typeof I.value < "u" ? I.value : j[I];
      if (!(p && G === null)) {
        var x = a(j) ? typeof w == "function" ? w(V, I) : V : V + (Y ? "." + I : "[" + I + "]");
        K.set(y, se);
        var k = e();
        k.set(c, K), i(F, u(
          G,
          x,
          w,
          h,
          g,
          p,
          w === "comma" && H && a(j) ? null : P,
          _,
          A,
          Y,
          q,
          X,
          J,
          H,
          Z,
          k
        ));
      }
    }
    return F;
  }, v = function(u) {
    if (!u)
      return f;
    if (u.encoder !== null && typeof u.encoder < "u" && typeof u.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var y = u.charset || f.charset;
    if (typeof u.charset < "u" && u.charset !== "utf-8" && u.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var S = r.default;
    if (typeof u.format < "u") {
      if (!n.call(r.formatters, u.format))
        throw new TypeError("Unknown format option provided.");
      S = u.format;
    }
    var w = r.formatters[S], h = f.filter;
    return (typeof u.filter == "function" || a(u.filter)) && (h = u.filter), {
      addQueryPrefix: typeof u.addQueryPrefix == "boolean" ? u.addQueryPrefix : f.addQueryPrefix,
      allowDots: typeof u.allowDots > "u" ? f.allowDots : !!u.allowDots,
      charset: y,
      charsetSentinel: typeof u.charsetSentinel == "boolean" ? u.charsetSentinel : f.charsetSentinel,
      delimiter: typeof u.delimiter > "u" ? f.delimiter : u.delimiter,
      encode: typeof u.encode == "boolean" ? u.encode : f.encode,
      encoder: typeof u.encoder == "function" ? u.encoder : f.encoder,
      encodeValuesOnly: typeof u.encodeValuesOnly == "boolean" ? u.encodeValuesOnly : f.encodeValuesOnly,
      filter: h,
      format: S,
      formatter: w,
      serializeDate: typeof u.serializeDate == "function" ? u.serializeDate : f.serializeDate,
      skipNulls: typeof u.skipNulls == "boolean" ? u.skipNulls : f.skipNulls,
      sort: typeof u.sort == "function" ? u.sort : null,
      strictNullHandling: typeof u.strictNullHandling == "boolean" ? u.strictNullHandling : f.strictNullHandling
    };
  };
  return Xt = function(u, y) {
    var S = u, w = v(y), h, g;
    typeof w.filter == "function" ? (g = w.filter, S = g("", S)) : a(w.filter) && (g = w.filter, h = g);
    var p = [];
    if (typeof S != "object" || S === null)
      return "";
    var P;
    y && y.arrayFormat in o ? P = y.arrayFormat : y && "indices" in y ? P = y.indices ? "indices" : "repeat" : P = "indices";
    var _ = o[P];
    if (y && "commaRoundTrip" in y && typeof y.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var A = _ === "comma" && y && y.commaRoundTrip;
    h || (h = Object.keys(S)), w.sort && h.sort(w.sort);
    for (var Y = e(), q = 0; q < h.length; ++q) {
      var X = h[q];
      w.skipNulls && S[X] === null || i(p, d(
        S[X],
        X,
        _,
        A,
        w.strictNullHandling,
        w.skipNulls,
        w.encode ? w.encoder : null,
        w.filter,
        w.sort,
        w.allowDots,
        w.serializeDate,
        w.format,
        w.formatter,
        w.encodeValuesOnly,
        w.charset,
        Y
      ));
    }
    var J = p.join(w.delimiter), H = w.addQueryPrefix === !0 ? "?" : "";
    return w.charsetSentinel && (w.charset === "iso-8859-1" ? H += "utf8=%26%2310003%3B&" : H += "utf8=%E2%9C%93&"), J.length > 0 ? H + J : "";
  }, Xt;
}
var Jt, yo;
function Ii() {
  if (yo)
    return Jt;
  yo = 1;
  var e = Ko(), t = Object.prototype.hasOwnProperty, r = Array.isArray, n = {
    allowDots: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decoder: e.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictNullHandling: !1
  }, o = function(c) {
    return c.replace(/&#(\d+);/g, function(d, v) {
      return String.fromCharCode(parseInt(v, 10));
    });
  }, a = function(c, d) {
    return c && typeof c == "string" && d.comma && c.indexOf(",") > -1 ? c.split(",") : c;
  }, s = "utf8=%26%2310003%3B", i = "utf8=%E2%9C%93", m = function(c, d) {
    var v = {}, u = d.ignoreQueryPrefix ? c.replace(/^\?/, "") : c, y = d.parameterLimit === 1 / 0 ? void 0 : d.parameterLimit, S = u.split(d.delimiter, y), w = -1, h, g = d.charset;
    if (d.charsetSentinel)
      for (h = 0; h < S.length; ++h)
        S[h].indexOf("utf8=") === 0 && (S[h] === i ? g = "utf-8" : S[h] === s && (g = "iso-8859-1"), w = h, h = S.length);
    for (h = 0; h < S.length; ++h)
      if (h !== w) {
        var p = S[h], P = p.indexOf("]="), _ = P === -1 ? p.indexOf("=") : P + 1, A, Y;
        _ === -1 ? (A = d.decoder(p, n.decoder, g, "key"), Y = d.strictNullHandling ? null : "") : (A = d.decoder(p.slice(0, _), n.decoder, g, "key"), Y = e.maybeMap(
          a(p.slice(_ + 1), d),
          function(q) {
            return d.decoder(q, n.decoder, g, "value");
          }
        )), Y && d.interpretNumericEntities && g === "iso-8859-1" && (Y = o(Y)), p.indexOf("[]=") > -1 && (Y = r(Y) ? [Y] : Y), t.call(v, A) ? v[A] = e.combine(v[A], Y) : v[A] = Y;
      }
    return v;
  }, l = function(c, d, v, u) {
    for (var y = u ? d : a(d, v), S = c.length - 1; S >= 0; --S) {
      var w, h = c[S];
      if (h === "[]" && v.parseArrays)
        w = [].concat(y);
      else {
        w = v.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
        var g = h.charAt(0) === "[" && h.charAt(h.length - 1) === "]" ? h.slice(1, -1) : h, p = parseInt(g, 10);
        !v.parseArrays && g === "" ? w = { 0: y } : !isNaN(p) && h !== g && String(p) === g && p >= 0 && v.parseArrays && p <= v.arrayLimit ? (w = [], w[p] = y) : g !== "__proto__" && (w[g] = y);
      }
      y = w;
    }
    return y;
  }, f = function(c, d, v, u) {
    if (c) {
      var y = v.allowDots ? c.replace(/\.([^.[]+)/g, "[$1]") : c, S = /(\[[^[\]]*])/, w = /(\[[^[\]]*])/g, h = v.depth > 0 && S.exec(y), g = h ? y.slice(0, h.index) : y, p = [];
      if (g) {
        if (!v.plainObjects && t.call(Object.prototype, g) && !v.allowPrototypes)
          return;
        p.push(g);
      }
      for (var P = 0; v.depth > 0 && (h = w.exec(y)) !== null && P < v.depth; ) {
        if (P += 1, !v.plainObjects && t.call(Object.prototype, h[1].slice(1, -1)) && !v.allowPrototypes)
          return;
        p.push(h[1]);
      }
      return h && p.push("[" + y.slice(h.index) + "]"), l(p, d, v, u);
    }
  }, b = function(c) {
    if (!c)
      return n;
    if (c.decoder !== null && c.decoder !== void 0 && typeof c.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof c.charset < "u" && c.charset !== "utf-8" && c.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var d = typeof c.charset > "u" ? n.charset : c.charset;
    return {
      allowDots: typeof c.allowDots > "u" ? n.allowDots : !!c.allowDots,
      allowPrototypes: typeof c.allowPrototypes == "boolean" ? c.allowPrototypes : n.allowPrototypes,
      allowSparse: typeof c.allowSparse == "boolean" ? c.allowSparse : n.allowSparse,
      arrayLimit: typeof c.arrayLimit == "number" ? c.arrayLimit : n.arrayLimit,
      charset: d,
      charsetSentinel: typeof c.charsetSentinel == "boolean" ? c.charsetSentinel : n.charsetSentinel,
      comma: typeof c.comma == "boolean" ? c.comma : n.comma,
      decoder: typeof c.decoder == "function" ? c.decoder : n.decoder,
      delimiter: typeof c.delimiter == "string" || e.isRegExp(c.delimiter) ? c.delimiter : n.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof c.depth == "number" || c.depth === !1 ? +c.depth : n.depth,
      ignoreQueryPrefix: c.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof c.interpretNumericEntities == "boolean" ? c.interpretNumericEntities : n.interpretNumericEntities,
      parameterLimit: typeof c.parameterLimit == "number" ? c.parameterLimit : n.parameterLimit,
      parseArrays: c.parseArrays !== !1,
      plainObjects: typeof c.plainObjects == "boolean" ? c.plainObjects : n.plainObjects,
      strictNullHandling: typeof c.strictNullHandling == "boolean" ? c.strictNullHandling : n.strictNullHandling
    };
  };
  return Jt = function(c, d) {
    var v = b(d);
    if (c === "" || c === null || typeof c > "u")
      return v.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
    for (var u = typeof c == "string" ? m(c, v) : c, y = v.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, S = Object.keys(u), w = 0; w < S.length; ++w) {
      var h = S[w], g = f(h, u[h], v, typeof c == "string");
      y = e.merge(y, g, v);
    }
    return v.allowSparse === !0 ? y : e.compact(y);
  }, Jt;
}
var Kt, vo;
function Li() {
  if (vo)
    return Kt;
  vo = 1;
  var e = ji(), t = Ii(), r = Er();
  return Kt = {
    formats: r,
    parse: t,
    stringify: e
  }, Kt;
}
var Di = Li();
const Fi = { Accept: "application/json, text/plain, */*" };
let Qt, er;
const tr = [];
class vt {
  /**
   * update headers of all providers
   * @param headers request's additional headers
   * @return void
   */
  static setHeaders(t) {
    for (const r of tr)
      r.setHeaders(t);
  }
  /**
   * update request's params object of all providers
   * @param requestParameters request's params object
   * @return void
   */
  static setRequestParams(t) {
    for (const r of tr)
      r.setRequestParams(t);
  }
  /**
   * set callback for every response of all providers
   * @param function_ callback
   * @return void
   */
  static setResponseCallback(t) {
    Qt = t;
  }
  /**
   * set callback for every response of all providers that has errors
   * @param function_ callback
   * @return void
   */
  static setResponseErrorCallback(t) {
    er = t;
  }
  /**
   * create new RestClient instance - 'provider'
   * @param path provider rest point
   * @param headers headers object
   * @param restPath endpoint for all requests
   * @param requestParameters request's params object
   */
  constructor(t, r = {}, n = "", o = {}) {
    this.path = t, this.restPath = n, this.headers = { ...Fi, ...r }, this.requestParams = o, tr.push(this);
  }
  /**
   * update headers of current provider
   * @param headers updating headers
   * @return void
   */
  setHeaders(t) {
    this.headers = { ...this.headers, ...t };
  }
  /**
   * update requests params of current provider
   * @param requestParameters request's params object
   * @return void
   */
  setRequestParams(t) {
    this.requestParams = { ...this.requestParams, ...t };
  }
  /**
   * GET-request
   * @param path request's path, relative to provider's path
   * @param query request's query params
   * @param headers request's additional headers
   * @param requestParameters request's params object
   * @param stringifyOptions Stringify Options
   * @return Promise<R>
   */
  get(t, r = {}, n = null, o = {}, a) {
    const s = Object.keys(r), i = t + (s.length > 0 ? `?${Di.stringify(r, { indices: !1, ...a })}` : "");
    return this.request("GET", i, null, n, o);
  }
  /**
   * POST-request
   * @param path request's path, relative to provider's path
   * @param body request's body
   * @param headers request's additional headers
   * @param requestParameters request's params object
   * @return Promise<R>
   */
  post(t, r, n = null, o = {}) {
    return this.request("POST", t, r, n, o);
  }
  /**
   * PUT-request
   * @param path request's path, relative to provider's path
   * @param body request's body
   * @param headers request's additional headers
   * @param requestParameters request's params object
   * @return Promise<R>
   */
  put(t, r, n = null, o = {}) {
    return this.request("PUT", t, r, n, o);
  }
  /**
   * PATCH-request
   * @param path request's path, relative to provider's path
   * @param body request's body
   * @param headers request's additional headers
   * @param requestParameters request's params object
   * @return Promise<R>
   */
  patch(t, r, n = null, o = {}) {
    return this.request("PATCH", t, r, n, o);
  }
  /**
   * DELETE-request
   * @param path request's path, relative to provider's path
   * @param headers request's additional headers
   * @param body request's body
   * @param requestParameters request's params object
   * @return Promise<R>
   */
  delete(t, r = null, n, o = {}) {
    return this.request("DELETE", t, n, r, o);
  }
  upload(t, r, n, o) {
    const a = new XMLHttpRequest();
    return a.upload.addEventListener("progress", n, !1), a.addEventListener("load", o, !1), a.open("POST", this.restPath + this.path + t, !0), new Promise((s, i) => {
      a.addEventListener("readystatechange", () => {
        a.readyState === 4 && (a.status >= 200 && a.status < 300 ? s(JSON.parse(a.responseText)) : i(a.responseText));
      }), a.send(r);
    });
  }
  // eslint-disable-next-line sonarjs/cognitive-complexity
  request(t, r, n, o = null, a = {}) {
    const s = r.charAt(0) === "/" ? "" : "/", i = r.charAt(0) === "?" ? "" : s, m = r ? i : "", l = this.restPath + this.path + m + r, f = {
      ...this.requestParams,
      ...a,
      method: t,
      headers: {
        ...this.headers,
        ...this.requestParams.headers,
        ...a.headers,
        ...o
      }
    };
    return n && (f.body = JSON.stringify(n)), f.credentials = "include", fetch(l, f).then((b) => {
      if (typeof Qt == "function" && Qt(b), b.ok) {
        if (b.status === 204)
          return null;
        const c = b.clone();
        return b.json().catch(() => {
          var d;
          return ((d = f.headers) == null ? void 0 : d["Content-Type"]) === "application/json" ? null : c.text();
        });
      }
      return b.json().then((c) => {
        throw typeof c == "object" && (c.response = b), typeof er == "function" && er(c), c;
      });
    });
  }
}
typeof window < "u" && (window.affstoreDsRestClient = { RestClient: vt });
var Qo = /* @__PURE__ */ ((e) => (e.ExportAffiliateMetricsController_exportMetrics = "/api/statistics/affiliate/export/:exportType", e.ExportMobileMetricsController_exportMetrics = "/api/statistics/mobile/export/:exportType", e.ExportTraderMetricsController_exportMetrics = "/api/statistics/trader/export/:exportType", e.TraderMetricsSettingsController_getSettings = "/api/v3/statistics/trader/settings", e.AffiliateMetricsSettingsController_getSettings = "/api/v3/statistics/affiliate/settings", e.PingController_ping = "/api/ping", e.SignupController_signup = "/api/auth/signup", e.EmailConfirmController_confirm = "/api/auth/email-confirm", e.EmailConfirmController_request = "/api/auth/email-confirm/request", e.ResetPasswordController_request = "/api/auth/reset-password/request", e.ResetPasswordController_reset = "/api/auth/reset-password/reset", e.CountriesController_countries = "/api/dictionary/countries", e.CountriesV3Controller_countries = "/api/v3/countries", e.CountriesV3IpController_countries = "/api/v3/country-ip", e.OnboardingController_pass = "/api/v3/user/onboarding", e.OnboardingController_preferableLanguages = "/api/v3/user/onboarding/support-languages", e.PhoneController_requestAdding = "/api/v3/user/phone/request-adding", e.PhoneController_requestRemoving = "/api/v3/user/phone/request-removing", e.PhoneController_remove = "/api/v3/user/phone/remove", e.PhoneController_add = "/api/v3/user/phone/add", e.SubscriptionController_newsletter = "/api/v3/user/subscription/newsletter", e.AffTracksController_getAffTracks = "/api/v3/statistics/afftracks", e.AffTracksController_getReferralsAffTracks = "/api/v3/statistics/referrals/afftracks", e.AffiliateController_getAffiliate = "/api/v3/user", e.AffiliateController_updateProfile = "/api/v3/user", e.ChangePasswordController_post = "/api/v3/auth/reset-password", e.PaymentAccountController_confirm = "/api/payment-account/confirm/:token", e.AccessController_getToken = "/api/support/access", e.LogoutController_getToken = "/api/support/logout", e.AssignController_getToken = "/api/support/assign/manager", e.PaymentAccountControllerV3_confirm = "/api/v3/payment-account/confirm/:token", e))(Qo || {}), ea = /* @__PURE__ */ ((e) => (e.PostApiV1Events = "/api/v1/events", e))(ea || {});
const mo = "https://api.affstore.com", Ni = "https://api.int.affstore.com", Vi = (e) => {
  var t;
  return (t = e.match(/(affstore|my-affiliate).build/)) == null ? void 0 : t.input;
}, ta = (e) => {
  const t = typeof window > "u" ? "" : window.location.hostname;
  if (e)
    return mo;
  switch (t) {
    case "my.affstore.com":
    case "affstore.com":
      return mo;
    case "localhost":
    case "int.affstore.com":
    case "my.int.affstore.com":
      return Ni;
    case Vi(t):
      return `https://api-affiliate.${t.replace("my-affiliate.", "")}`;
    default:
      return "";
  }
}, Wi = new vt(Qo.CountriesV3IpController_countries, {}, ta(), {
  mode: "cors",
  referrerPolicy: "no-referrer"
}), Yi = async () => await Wi.get(""), Gi = new vt(ea.PostApiV1Events, {}, ta(), {
  mode: "cors",
  referrerPolicy: "no-referrer"
}), Ui = async (e, t) => {
  const n = {
    "Content-Type": "application/json",
    "X-Action": Array.isArray(e) ? "bulk" : "single",
    "X-Brand-Id": String(t)
  };
  await Gi.post("", e, n);
};
function bo(e) {
  e && tt.event(e);
}
let rr = null;
const Bi = async () => (rr === null && (rr = Yi().then((e) => e.code).catch((e) => (console.error(e), "ZZ"))), rr);
function zi(e) {
  e && !tt.isInitialized && tt.initialize(e);
}
let Je = {};
const Zi = () => {
  Je = {};
}, ra = async (e) => {
  const t = e.countryId || await Bi();
  return { ...Je, ...e, ...t ? { countryId: t } : {} };
}, qi = async (e) => {
  Zi(), Je = await ra(e);
}, Hi = async () => ra(Je), $i = (e) => {
  zi(e.gaMeasurementId), Je = { ...Je, ...e };
}, Sr = { get: Hi, init: qi, set: $i }, Xi = (e) => {
  const r = new URL(e).searchParams, n = {};
  r.has("ref_id") && (n.source = "referral", n.utm_source = "referral", n.utm_medium = "link", n.utm_campaign = r.get("ref_id") || "");
  for (const [o, a] of r)
    (o.startsWith("utm_") || o === "manager" || o === "keyword" || o === "ref_id" || o === "source") && (n[o] = a);
  return n;
}, Ji = 149, na = "ui", Ki = "en", Qi = 1;
var nt = function() {
  return nt = Object.assign || function(t) {
    for (var r, n = 1, o = arguments.length; n < o; n++) {
      r = arguments[n];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, nt.apply(this, arguments);
};
function ec(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
}
function Le(e, t, r, n) {
  function o(a) {
    return a instanceof r ? a : new r(function(s) {
      s(a);
    });
  }
  return new (r || (r = Promise))(function(a, s) {
    function i(f) {
      try {
        l(n.next(f));
      } catch (b) {
        s(b);
      }
    }
    function m(f) {
      try {
        l(n.throw(f));
      } catch (b) {
        s(b);
      }
    }
    function l(f) {
      f.done ? a(f.value) : o(f.value).then(i, m);
    }
    l((n = n.apply(e, t || [])).next());
  });
}
function De(e, t) {
  var r = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, o, a, s;
  return s = { next: i(0), throw: i(1), return: i(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function i(l) {
    return function(f) {
      return m([l, f]);
    };
  }
  function m(l) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; s && (s = 0, l[0] && (r = 0)), r; )
      try {
        if (n = 1, o && (a = l[0] & 2 ? o.return : l[0] ? o.throw || ((a = o.return) && a.call(o), 0) : o.next) && !(a = a.call(o, l[1])).done)
          return a;
        switch (o = 0, a && (l = [l[0] & 2, a.value]), l[0]) {
          case 0:
          case 1:
            a = l;
            break;
          case 4:
            return r.label++, { value: l[1], done: !1 };
          case 5:
            r.label++, o = l[1], l = [0];
            continue;
          case 7:
            l = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (a = r.trys, !(a = a.length > 0 && a[a.length - 1]) && (l[0] === 6 || l[0] === 2)) {
              r = 0;
              continue;
            }
            if (l[0] === 3 && (!a || l[1] > a[0] && l[1] < a[3])) {
              r.label = l[1];
              break;
            }
            if (l[0] === 6 && r.label < a[1]) {
              r.label = a[1], a = l;
              break;
            }
            if (a && r.label < a[2]) {
              r.label = a[2], r.ops.push(l);
              break;
            }
            a[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        l = t.call(e, r);
      } catch (f) {
        l = [6, f], o = 0;
      } finally {
        n = a = 0;
      }
    if (l[0] & 5)
      throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}
function Rr(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, o = t.length, a; n < o; n++)
      (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var oa = "3.4.2";
function ot(e, t) {
  return new Promise(function(r) {
    return setTimeout(r, e, t);
  });
}
function tc(e, t) {
  t === void 0 && (t = 1 / 0);
  var r = window.requestIdleCallback;
  return r ? new Promise(function(n) {
    return r.call(window, function() {
      return n();
    }, { timeout: t });
  }) : ot(Math.min(e, t));
}
function aa(e) {
  return !!e && typeof e.then == "function";
}
function ho(e, t) {
  try {
    var r = e();
    aa(r) ? r.then(function(n) {
      return t(!0, n);
    }, function(n) {
      return t(!1, n);
    }) : t(!0, r);
  } catch (n) {
    t(!1, n);
  }
}
function go(e, t, r) {
  return r === void 0 && (r = 16), Le(this, void 0, void 0, function() {
    var n, o, a, s;
    return De(this, function(i) {
      switch (i.label) {
        case 0:
          n = Array(e.length), o = Date.now(), a = 0, i.label = 1;
        case 1:
          return a < e.length ? (n[a] = t(e[a], a), s = Date.now(), s >= o + r ? (o = s, [4, ot(0)]) : [3, 3]) : [3, 4];
        case 2:
          i.sent(), i.label = 3;
        case 3:
          return ++a, [3, 1];
        case 4:
          return [2, n];
      }
    });
  });
}
function at(e) {
  e.then(void 0, function() {
  });
}
function We(e, t) {
  e = [e[0] >>> 16, e[0] & 65535, e[1] >>> 16, e[1] & 65535], t = [t[0] >>> 16, t[0] & 65535, t[1] >>> 16, t[1] & 65535];
  var r = [0, 0, 0, 0];
  return r[3] += e[3] + t[3], r[2] += r[3] >>> 16, r[3] &= 65535, r[2] += e[2] + t[2], r[1] += r[2] >>> 16, r[2] &= 65535, r[1] += e[1] + t[1], r[0] += r[1] >>> 16, r[1] &= 65535, r[0] += e[0] + t[0], r[0] &= 65535, [r[0] << 16 | r[1], r[2] << 16 | r[3]];
}
function Pe(e, t) {
  e = [e[0] >>> 16, e[0] & 65535, e[1] >>> 16, e[1] & 65535], t = [t[0] >>> 16, t[0] & 65535, t[1] >>> 16, t[1] & 65535];
  var r = [0, 0, 0, 0];
  return r[3] += e[3] * t[3], r[2] += r[3] >>> 16, r[3] &= 65535, r[2] += e[2] * t[3], r[1] += r[2] >>> 16, r[2] &= 65535, r[2] += e[3] * t[2], r[1] += r[2] >>> 16, r[2] &= 65535, r[1] += e[1] * t[3], r[0] += r[1] >>> 16, r[1] &= 65535, r[1] += e[2] * t[2], r[0] += r[1] >>> 16, r[1] &= 65535, r[1] += e[3] * t[1], r[0] += r[1] >>> 16, r[1] &= 65535, r[0] += e[0] * t[3] + e[1] * t[2] + e[2] * t[1] + e[3] * t[0], r[0] &= 65535, [r[0] << 16 | r[1], r[2] << 16 | r[3]];
}
function Ze(e, t) {
  return t %= 64, t === 32 ? [e[1], e[0]] : t < 32 ? [e[0] << t | e[1] >>> 32 - t, e[1] << t | e[0] >>> 32 - t] : (t -= 32, [e[1] << t | e[0] >>> 32 - t, e[0] << t | e[1] >>> 32 - t]);
}
function _e(e, t) {
  return t %= 64, t === 0 ? e : t < 32 ? [e[0] << t | e[1] >>> 32 - t, e[1] << t] : [e[1] << t - 32, 0];
}
function ye(e, t) {
  return [e[0] ^ t[0], e[1] ^ t[1]];
}
function wo(e) {
  return e = ye(e, [0, e[0] >>> 1]), e = Pe(e, [4283543511, 3981806797]), e = ye(e, [0, e[0] >>> 1]), e = Pe(e, [3301882366, 444984403]), e = ye(e, [0, e[0] >>> 1]), e;
}
function rc(e, t) {
  e = e || "", t = t || 0;
  var r = e.length % 16, n = e.length - r, o = [0, t], a = [0, t], s = [0, 0], i = [0, 0], m = [2277735313, 289559509], l = [1291169091, 658871167], f;
  for (f = 0; f < n; f = f + 16)
    s = [
      e.charCodeAt(f + 4) & 255 | (e.charCodeAt(f + 5) & 255) << 8 | (e.charCodeAt(f + 6) & 255) << 16 | (e.charCodeAt(f + 7) & 255) << 24,
      e.charCodeAt(f) & 255 | (e.charCodeAt(f + 1) & 255) << 8 | (e.charCodeAt(f + 2) & 255) << 16 | (e.charCodeAt(f + 3) & 255) << 24
    ], i = [
      e.charCodeAt(f + 12) & 255 | (e.charCodeAt(f + 13) & 255) << 8 | (e.charCodeAt(f + 14) & 255) << 16 | (e.charCodeAt(f + 15) & 255) << 24,
      e.charCodeAt(f + 8) & 255 | (e.charCodeAt(f + 9) & 255) << 8 | (e.charCodeAt(f + 10) & 255) << 16 | (e.charCodeAt(f + 11) & 255) << 24
    ], s = Pe(s, m), s = Ze(s, 31), s = Pe(s, l), o = ye(o, s), o = Ze(o, 27), o = We(o, a), o = We(Pe(o, [0, 5]), [0, 1390208809]), i = Pe(i, l), i = Ze(i, 33), i = Pe(i, m), a = ye(a, i), a = Ze(a, 31), a = We(a, o), a = We(Pe(a, [0, 5]), [0, 944331445]);
  switch (s = [0, 0], i = [0, 0], r) {
    case 15:
      i = ye(i, _e([0, e.charCodeAt(f + 14)], 48));
    case 14:
      i = ye(i, _e([0, e.charCodeAt(f + 13)], 40));
    case 13:
      i = ye(i, _e([0, e.charCodeAt(f + 12)], 32));
    case 12:
      i = ye(i, _e([0, e.charCodeAt(f + 11)], 24));
    case 11:
      i = ye(i, _e([0, e.charCodeAt(f + 10)], 16));
    case 10:
      i = ye(i, _e([0, e.charCodeAt(f + 9)], 8));
    case 9:
      i = ye(i, [0, e.charCodeAt(f + 8)]), i = Pe(i, l), i = Ze(i, 33), i = Pe(i, m), a = ye(a, i);
    case 8:
      s = ye(s, _e([0, e.charCodeAt(f + 7)], 56));
    case 7:
      s = ye(s, _e([0, e.charCodeAt(f + 6)], 48));
    case 6:
      s = ye(s, _e([0, e.charCodeAt(f + 5)], 40));
    case 5:
      s = ye(s, _e([0, e.charCodeAt(f + 4)], 32));
    case 4:
      s = ye(s, _e([0, e.charCodeAt(f + 3)], 24));
    case 3:
      s = ye(s, _e([0, e.charCodeAt(f + 2)], 16));
    case 2:
      s = ye(s, _e([0, e.charCodeAt(f + 1)], 8));
    case 1:
      s = ye(s, [0, e.charCodeAt(f)]), s = Pe(s, m), s = Ze(s, 31), s = Pe(s, l), o = ye(o, s);
  }
  return o = ye(o, [0, e.length]), a = ye(a, [0, e.length]), o = We(o, a), a = We(a, o), o = wo(o), a = wo(a), o = We(o, a), a = We(a, o), ("00000000" + (o[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (o[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (a[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (a[1] >>> 0).toString(16)).slice(-8);
}
function nc(e) {
  var t;
  return nt({ name: e.name, message: e.message, stack: (t = e.stack) === null || t === void 0 ? void 0 : t.split(`
`) }, e);
}
function oc(e, t) {
  for (var r = 0, n = e.length; r < n; ++r)
    if (e[r] === t)
      return !0;
  return !1;
}
function ac(e, t) {
  return !oc(e, t);
}
function Or(e) {
  return parseInt(e);
}
function Ce(e) {
  return parseFloat(e);
}
function Ie(e, t) {
  return typeof e == "number" && isNaN(e) ? t : e;
}
function xe(e) {
  return e.reduce(function(t, r) {
    return t + (r ? 1 : 0);
  }, 0);
}
function ia(e, t) {
  if (t === void 0 && (t = 1), Math.abs(t) >= 1)
    return Math.round(e / t) * t;
  var r = 1 / t;
  return Math.round(e * r) / r;
}
function ic(e) {
  for (var t, r, n = "Unexpected syntax '".concat(e, "'"), o = /^\s*([a-z-]*)(.*)$/i.exec(e), a = o[1] || void 0, s = {}, i = /([.:#][\w-]+|\[.+?\])/gi, m = function(c, d) {
    s[c] = s[c] || [], s[c].push(d);
  }; ; ) {
    var l = i.exec(o[2]);
    if (!l)
      break;
    var f = l[0];
    switch (f[0]) {
      case ".":
        m("class", f.slice(1));
        break;
      case "#":
        m("id", f.slice(1));
        break;
      case "[": {
        var b = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(f);
        if (b)
          m(b[1], (r = (t = b[4]) !== null && t !== void 0 ? t : b[5]) !== null && r !== void 0 ? r : "");
        else
          throw new Error(n);
        break;
      }
      default:
        throw new Error(n);
    }
  }
  return [a, s];
}
function Eo(e) {
  return e && typeof e == "object" && "message" in e ? e : { message: e };
}
function cc(e) {
  return typeof e != "function";
}
function uc(e, t) {
  var r = new Promise(function(n) {
    var o = Date.now();
    ho(e.bind(null, t), function() {
      for (var a = [], s = 0; s < arguments.length; s++)
        a[s] = arguments[s];
      var i = Date.now() - o;
      if (!a[0])
        return n(function() {
          return { error: Eo(a[1]), duration: i };
        });
      var m = a[1];
      if (cc(m))
        return n(function() {
          return { value: m, duration: i };
        });
      n(function() {
        return new Promise(function(l) {
          var f = Date.now();
          ho(m, function() {
            for (var b = [], c = 0; c < arguments.length; c++)
              b[c] = arguments[c];
            var d = i + Date.now() - f;
            if (!b[0])
              return l({ error: Eo(b[1]), duration: d });
            l({ value: b[1], duration: d });
          });
        });
      });
    });
  });
  return at(r), function() {
    return r.then(function(o) {
      return o();
    });
  };
}
function sc(e, t, r) {
  var n = Object.keys(e).filter(function(a) {
    return ac(r, a);
  }), o = go(n, function(a) {
    return uc(e[a], t);
  });
  return at(o), function() {
    return Le(this, void 0, void 0, function() {
      var s, i, m, l, f;
      return De(this, function(b) {
        switch (b.label) {
          case 0:
            return [4, o];
          case 1:
            return s = b.sent(), [4, go(s, function(c) {
              var d = c();
              return at(d), d;
            })];
          case 2:
            return i = b.sent(), [
              4,
              Promise.all(i)
              // Keeping the component keys order the same as the source keys order
            ];
          case 3:
            for (m = b.sent(), l = {}, f = 0; f < n.length; ++f)
              l[n[f]] = m[f];
            return [2, l];
        }
      });
    });
  };
}
function ca() {
  var e = window, t = navigator;
  return xe([
    "MSCSSMatrix" in e,
    "msSetImmediate" in e,
    "msIndexedDB" in e,
    "msMaxTouchPoints" in t,
    "msPointerEnabled" in t
  ]) >= 4;
}
function fc() {
  var e = window, t = navigator;
  return xe(["msWriteProfilerMark" in e, "MSStream" in e, "msLaunchUri" in t, "msSaveBlob" in t]) >= 3 && !ca();
}
function _r() {
  var e = window, t = navigator;
  return xe([
    "webkitPersistentStorage" in t,
    "webkitTemporaryStorage" in t,
    t.vendor.indexOf("Google") === 0,
    "webkitResolveLocalFileSystemURL" in e,
    "BatteryManager" in e,
    "webkitMediaStream" in e,
    "webkitSpeechGrammar" in e
  ]) >= 5;
}
function it() {
  var e = window, t = navigator;
  return xe([
    "ApplePayError" in e,
    "CSSPrimitiveValue" in e,
    "Counter" in e,
    t.vendor.indexOf("Apple") === 0,
    "getStorageUpdates" in t,
    "WebKitMediaKeys" in e
  ]) >= 4;
}
function Tr() {
  var e = window;
  return xe([
    "safari" in e,
    !("DeviceMotionEvent" in e),
    !("ongestureend" in e),
    !("standalone" in navigator)
  ]) >= 3;
}
function lc() {
  var e, t, r = window;
  return xe([
    "buildID" in navigator,
    "MozAppearance" in ((t = (e = document.documentElement) === null || e === void 0 ? void 0 : e.style) !== null && t !== void 0 ? t : {}),
    "onmozfullscreenchange" in r,
    "mozInnerScreenX" in r,
    "CSSMozDocumentRule" in r,
    "CanvasCaptureMediaStream" in r
  ]) >= 4;
}
function pc() {
  var e = window;
  return xe([
    !("MediaSettingsRange" in e),
    "RTCEncodedAudioFrame" in e,
    "" + e.Intl == "[object Intl]",
    "" + e.Reflect == "[object Reflect]"
  ]) >= 3;
}
function dc() {
  var e = window;
  return xe([
    "DOMRectList" in e,
    "RTCPeerConnectionIceEvent" in e,
    "SVGGeometryElement" in e,
    "ontransitioncancel" in e
  ]) >= 3;
}
function yc() {
  if (navigator.platform === "iPad")
    return !0;
  var e = screen, t = e.width / e.height;
  return xe([
    "MediaSource" in window,
    !!Element.prototype.webkitRequestFullscreen,
    // iPhone 4S that runs iOS 9 matches this. But it won't match the criteria above, so it won't be detected as iPad.
    t > 0.65 && t < 1.53
  ]) >= 2;
}
function vc() {
  var e = document;
  return e.fullscreenElement || e.msFullscreenElement || e.mozFullScreenElement || e.webkitFullscreenElement || null;
}
function mc() {
  var e = document;
  return (e.exitFullscreen || e.msExitFullscreen || e.mozCancelFullScreen || e.webkitExitFullscreen).call(e);
}
function ua() {
  var e = _r(), t = lc();
  if (!e && !t)
    return !1;
  var r = window;
  return xe([
    "onorientationchange" in r,
    "orientation" in r,
    e && !("SharedWorker" in r),
    t && /android/i.test(navigator.appVersion)
  ]) >= 2;
}
function bc() {
  var e = window, t = e.OfflineAudioContext || e.webkitOfflineAudioContext;
  if (!t)
    return -2;
  if (hc())
    return -1;
  var r = 4500, n = 5e3, o = new t(1, n, 44100), a = o.createOscillator();
  a.type = "triangle", a.frequency.value = 1e4;
  var s = o.createDynamicsCompressor();
  s.threshold.value = -50, s.knee.value = 40, s.ratio.value = 12, s.attack.value = 0, s.release.value = 0.25, a.connect(s), s.connect(o.destination), a.start(0);
  var i = gc(o), m = i[0], l = i[1], f = m.then(function(b) {
    return wc(b.getChannelData(0).subarray(r));
  }, function(b) {
    if (b.name === "timeout" || b.name === "suspended")
      return -3;
    throw b;
  });
  return at(f), function() {
    return l(), f;
  };
}
function hc() {
  return it() && !Tr() && !dc();
}
function gc(e) {
  var t = 3, r = 500, n = 500, o = 5e3, a = function() {
  }, s = new Promise(function(i, m) {
    var l = !1, f = 0, b = 0;
    e.oncomplete = function(v) {
      return i(v.renderedBuffer);
    };
    var c = function() {
      setTimeout(function() {
        return m(So(
          "timeout"
          /* InnerErrorName.Timeout */
        ));
      }, Math.min(n, b + o - Date.now()));
    }, d = function() {
      try {
        var v = e.startRendering();
        switch (aa(v) && at(v), e.state) {
          case "running":
            b = Date.now(), l && c();
            break;
          case "suspended":
            document.hidden || f++, l && f >= t ? m(So(
              "suspended"
              /* InnerErrorName.Suspended */
            )) : setTimeout(d, r);
            break;
        }
      } catch (u) {
        m(u);
      }
    };
    d(), a = function() {
      l || (l = !0, b > 0 && c());
    };
  });
  return [s, a];
}
function wc(e) {
  for (var t = 0, r = 0; r < e.length; ++r)
    t += Math.abs(e[r]);
  return t;
}
function So(e) {
  var t = new Error(e);
  return t.name = e, t;
}
function sa(e, t, r) {
  var n, o, a;
  return r === void 0 && (r = 50), Le(this, void 0, void 0, function() {
    var s, i;
    return De(this, function(m) {
      switch (m.label) {
        case 0:
          s = document, m.label = 1;
        case 1:
          return s.body ? [3, 3] : [4, ot(r)];
        case 2:
          return m.sent(), [3, 1];
        case 3:
          i = s.createElement("iframe"), m.label = 4;
        case 4:
          return m.trys.push([4, , 10, 11]), [4, new Promise(function(l, f) {
            var b = !1, c = function() {
              b = !0, l();
            }, d = function(y) {
              b = !0, f(y);
            };
            i.onload = c, i.onerror = d;
            var v = i.style;
            v.setProperty("display", "block", "important"), v.position = "absolute", v.top = "0", v.left = "0", v.visibility = "hidden", t && "srcdoc" in i ? i.srcdoc = t : i.src = "about:blank", s.body.appendChild(i);
            var u = function() {
              var y, S;
              b || (((S = (y = i.contentWindow) === null || y === void 0 ? void 0 : y.document) === null || S === void 0 ? void 0 : S.readyState) === "complete" ? c() : setTimeout(u, 10));
            };
            u();
          })];
        case 5:
          m.sent(), m.label = 6;
        case 6:
          return !((o = (n = i.contentWindow) === null || n === void 0 ? void 0 : n.document) === null || o === void 0) && o.body ? [3, 8] : [4, ot(r)];
        case 7:
          return m.sent(), [3, 6];
        case 8:
          return [4, e(i, i.contentWindow)];
        case 9:
          return [2, m.sent()];
        case 10:
          return (a = i.parentNode) === null || a === void 0 || a.removeChild(i), [
            7
            /*endfinally*/
          ];
        case 11:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function Ec(e) {
  for (var t = ic(e), r = t[0], n = t[1], o = document.createElement(r ?? "div"), a = 0, s = Object.keys(n); a < s.length; a++) {
    var i = s[a], m = n[i].join(" ");
    i === "style" ? Sc(o.style, m) : o.setAttribute(i, m);
  }
  return o;
}
function Sc(e, t) {
  for (var r = 0, n = t.split(";"); r < n.length; r++) {
    var o = n[r], a = /^\s*([\w-]+)\s*:\s*(.+?)(\s*!([\w-]+))?\s*$/.exec(o);
    if (a) {
      var s = a[1], i = a[2], m = a[4];
      e.setProperty(s, i, m || "");
    }
  }
}
var Rc = "mmMwWLliI0O&1", Oc = "48px", qe = ["monospace", "sans-serif", "serif"], Ro = [
  // This is android-specific font from "Roboto" family
  "sans-serif-thin",
  "ARNO PRO",
  "Agency FB",
  "Arabic Typesetting",
  "Arial Unicode MS",
  "AvantGarde Bk BT",
  "BankGothic Md BT",
  "Batang",
  "Bitstream Vera Sans Mono",
  "Calibri",
  "Century",
  "Century Gothic",
  "Clarendon",
  "EUROSTILE",
  "Franklin Gothic",
  "Futura Bk BT",
  "Futura Md BT",
  "GOTHAM",
  "Gill Sans",
  "HELV",
  "Haettenschweiler",
  "Helvetica Neue",
  "Humanst521 BT",
  "Leelawadee",
  "Letter Gothic",
  "Levenim MT",
  "Lucida Bright",
  "Lucida Sans",
  "Menlo",
  "MS Mincho",
  "MS Outlook",
  "MS Reference Specialty",
  "MS UI Gothic",
  "MT Extra",
  "MYRIAD PRO",
  "Marlett",
  "Meiryo UI",
  "Microsoft Uighur",
  "Minion Pro",
  "Monotype Corsiva",
  "PMingLiU",
  "Pristina",
  "SCRIPTINA",
  "Segoe UI Light",
  "Serifa",
  "SimHei",
  "Small Fonts",
  "Staccato222 BT",
  "TRAJAN PRO",
  "Univers CE 55 Medium",
  "Vrinda",
  "ZWAdobeF"
];
function _c() {
  return sa(function(e, t) {
    var r = t.document, n = r.body;
    n.style.fontSize = Oc;
    var o = r.createElement("div"), a = {}, s = {}, i = function(u) {
      var y = r.createElement("span"), S = y.style;
      return S.position = "absolute", S.top = "0", S.left = "0", S.fontFamily = u, y.textContent = Rc, o.appendChild(y), y;
    }, m = function(u, y) {
      return i("'".concat(u, "',").concat(y));
    }, l = function() {
      return qe.map(i);
    }, f = function() {
      for (var u = {}, y = function(g) {
        u[g] = qe.map(function(p) {
          return m(g, p);
        });
      }, S = 0, w = Ro; S < w.length; S++) {
        var h = w[S];
        y(h);
      }
      return u;
    }, b = function(u) {
      return qe.some(function(y, S) {
        return u[S].offsetWidth !== a[y] || u[S].offsetHeight !== s[y];
      });
    }, c = l(), d = f();
    n.appendChild(o);
    for (var v = 0; v < qe.length; v++)
      a[qe[v]] = c[v].offsetWidth, s[qe[v]] = c[v].offsetHeight;
    return Ro.filter(function(u) {
      return b(d[u]);
    });
  });
}
function Tc() {
  var e = navigator.plugins;
  if (e) {
    for (var t = [], r = 0; r < e.length; ++r) {
      var n = e[r];
      if (n) {
        for (var o = [], a = 0; a < n.length; ++a) {
          var s = n[a];
          o.push({
            type: s.type,
            suffixes: s.suffixes
          });
        }
        t.push({
          name: n.name,
          description: n.description,
          mimeTypes: o
        });
      }
    }
    return t;
  }
}
function Pc() {
  var e = !1, t, r, n = Ac(), o = n[0], a = n[1];
  if (!Cc(o, a))
    t = r = "";
  else {
    e = xc(a), kc(o, a);
    var s = nr(o), i = nr(o);
    s !== i ? t = r = "unstable" : (r = s, Mc(o, a), t = nr(o));
  }
  return { winding: e, geometry: t, text: r };
}
function Ac() {
  var e = document.createElement("canvas");
  return e.width = 1, e.height = 1, [e, e.getContext("2d")];
}
function Cc(e, t) {
  return !!(t && e.toDataURL);
}
function xc(e) {
  return e.rect(0, 0, 10, 10), e.rect(2, 2, 6, 6), !e.isPointInPath(5, 5, "evenodd");
}
function kc(e, t) {
  e.width = 240, e.height = 60, t.textBaseline = "alphabetic", t.fillStyle = "#f60", t.fillRect(100, 1, 62, 20), t.fillStyle = "#069", t.font = '11pt "Times New Roman"';
  var r = "Cwm fjordbank gly ".concat(
    String.fromCharCode(55357, 56835)
    /* 😃 */
  );
  t.fillText(r, 2, 15), t.fillStyle = "rgba(102, 204, 0, 0.2)", t.font = "18pt Arial", t.fillText(r, 4, 45);
}
function Mc(e, t) {
  e.width = 122, e.height = 110, t.globalCompositeOperation = "multiply";
  for (var r = 0, n = [
    ["#f2f", 40, 40],
    ["#2ff", 80, 40],
    ["#ff2", 60, 80]
  ]; r < n.length; r++) {
    var o = n[r], a = o[0], s = o[1], i = o[2];
    t.fillStyle = a, t.beginPath(), t.arc(s, i, 40, 0, Math.PI * 2, !0), t.closePath(), t.fill();
  }
  t.fillStyle = "#f9c", t.arc(60, 60, 60, 0, Math.PI * 2, !0), t.arc(60, 60, 20, 0, Math.PI * 2, !0), t.fill("evenodd");
}
function nr(e) {
  return e.toDataURL();
}
function jc() {
  var e = navigator, t = 0, r;
  e.maxTouchPoints !== void 0 ? t = Or(e.maxTouchPoints) : e.msMaxTouchPoints !== void 0 && (t = e.msMaxTouchPoints);
  try {
    document.createEvent("TouchEvent"), r = !0;
  } catch {
    r = !1;
  }
  var n = "ontouchstart" in window;
  return {
    maxTouchPoints: t,
    touchEvent: r,
    touchStart: n
  };
}
function Ic() {
  return navigator.oscpu;
}
function Lc() {
  var e = navigator, t = [], r = e.language || e.userLanguage || e.browserLanguage || e.systemLanguage;
  if (r !== void 0 && t.push([r]), Array.isArray(e.languages))
    _r() && pc() || t.push(e.languages);
  else if (typeof e.languages == "string") {
    var n = e.languages;
    n && t.push(n.split(","));
  }
  return t;
}
function Dc() {
  return window.screen.colorDepth;
}
function Fc() {
  return Ie(Ce(navigator.deviceMemory), void 0);
}
function Nc() {
  var e = screen, t = function(n) {
    return Ie(Or(n), null);
  }, r = [t(e.width), t(e.height)];
  return r.sort().reverse(), r;
}
var Vc = 2500, Wc = 10, ft, or;
function Yc() {
  if (or === void 0) {
    var e = function() {
      var t = fr();
      lr(t) ? or = setTimeout(e, Vc) : (ft = t, or = void 0);
    };
    e();
  }
}
function Gc() {
  var e = this;
  return Yc(), function() {
    return Le(e, void 0, void 0, function() {
      var t;
      return De(this, function(r) {
        switch (r.label) {
          case 0:
            return t = fr(), lr(t) ? ft ? [2, Rr([], ft, !0)] : vc() ? [4, mc()] : [3, 2] : [3, 2];
          case 1:
            r.sent(), t = fr(), r.label = 2;
          case 2:
            return lr(t) || (ft = t), [2, t];
        }
      });
    });
  };
}
function Uc() {
  var e = this, t = Gc();
  return function() {
    return Le(e, void 0, void 0, function() {
      var r, n;
      return De(this, function(o) {
        switch (o.label) {
          case 0:
            return [4, t()];
          case 1:
            return r = o.sent(), n = function(a) {
              return a === null ? null : ia(a, Wc);
            }, [2, [n(r[0]), n(r[1]), n(r[2]), n(r[3])]];
        }
      });
    });
  };
}
function fr() {
  var e = screen;
  return [
    Ie(Ce(e.availTop), null),
    Ie(Ce(e.width) - Ce(e.availWidth) - Ie(Ce(e.availLeft), 0), null),
    Ie(Ce(e.height) - Ce(e.availHeight) - Ie(Ce(e.availTop), 0), null),
    Ie(Ce(e.availLeft), null)
  ];
}
function lr(e) {
  for (var t = 0; t < 4; ++t)
    if (e[t])
      return !1;
  return !0;
}
function Bc() {
  return Ie(Or(navigator.hardwareConcurrency), void 0);
}
function zc() {
  var e, t = (e = window.Intl) === null || e === void 0 ? void 0 : e.DateTimeFormat;
  if (t) {
    var r = new t().resolvedOptions().timeZone;
    if (r)
      return r;
  }
  var n = -Zc();
  return "UTC".concat(n >= 0 ? "+" : "").concat(Math.abs(n));
}
function Zc() {
  var e = (/* @__PURE__ */ new Date()).getFullYear();
  return Math.max(
    // `getTimezoneOffset` returns a number as a string in some unidentified cases
    Ce(new Date(e, 0, 1).getTimezoneOffset()),
    Ce(new Date(e, 6, 1).getTimezoneOffset())
  );
}
function qc() {
  try {
    return !!window.sessionStorage;
  } catch {
    return !0;
  }
}
function Hc() {
  try {
    return !!window.localStorage;
  } catch {
    return !0;
  }
}
function $c() {
  if (!(ca() || fc()))
    try {
      return !!window.indexedDB;
    } catch {
      return !0;
    }
}
function Xc() {
  return !!window.openDatabase;
}
function Jc() {
  return navigator.cpuClass;
}
function Kc() {
  var e = navigator.platform;
  return e === "MacIntel" && it() && !Tr() ? yc() ? "iPad" : "iPhone" : e;
}
function Qc() {
  return navigator.vendor || "";
}
function eu() {
  for (var e = [], t = 0, r = [
    // Blink and some browsers on iOS
    "chrome",
    // Safari on macOS
    "safari",
    // Chrome on iOS (checked in 85 on 13 and 87 on 14)
    "__crWeb",
    "__gCrWeb",
    // Yandex Browser on iOS, macOS and Android (checked in 21.2 on iOS 14, macOS and Android)
    "yandex",
    // Yandex Browser on iOS (checked in 21.2 on 14)
    "__yb",
    "__ybro",
    // Firefox on iOS (checked in 32 on 14)
    "__firefox__",
    // Edge on iOS (checked in 46 on 14)
    "__edgeTrackingPreventionStatistics",
    "webkit",
    // Opera Touch on iOS (checked in 2.6 on 14)
    "oprt",
    // Samsung Internet on Android (checked in 11.1)
    "samsungAr",
    // UC Browser on Android (checked in 12.10 and 13.0)
    "ucweb",
    "UCShellJava",
    // Puffin on Android (checked in 9.0)
    "puffinDevice"
    // UC on iOS and Opera on Android have no specific global variables
    // Edge for Android isn't checked
  ]; t < r.length; t++) {
    var n = r[t], o = window[n];
    o && typeof o == "object" && e.push(n);
  }
  return e.sort();
}
function tu() {
  var e = document;
  try {
    e.cookie = "cookietest=1; SameSite=Strict;";
    var t = e.cookie.indexOf("cookietest=") !== -1;
    return e.cookie = "cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT", t;
  } catch {
    return !1;
  }
}
function ru() {
  var e = atob;
  return {
    abpIndo: [
      "#Iklan-Melayang",
      "#Kolom-Iklan-728",
      "#SidebarIklan-wrapper",
      '[title="ALIENBOLA" i]',
      e("I0JveC1CYW5uZXItYWRz")
    ],
    abpvn: [".quangcao", "#mobileCatfish", e("LmNsb3NlLWFkcw=="), '[id^="bn_bottom_fixed_"]', "#pmadv"],
    adBlockFinland: [
      ".mainostila",
      e("LnNwb25zb3JpdA=="),
      ".ylamainos",
      e("YVtocmVmKj0iL2NsaWNrdGhyZ2guYXNwPyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hcHAucmVhZHBlYWsuY29tL2FkcyJd")
    ],
    adBlockPersian: [
      "#navbar_notice_50",
      ".kadr",
      'TABLE[width="140px"]',
      "#divAgahi",
      e("YVtocmVmXj0iaHR0cDovL2cxLnYuZndtcm0ubmV0L2FkLyJd")
    ],
    adBlockWarningRemoval: [
      "#adblock-honeypot",
      ".adblocker-root",
      ".wp_adblock_detect",
      e("LmhlYWRlci1ibG9ja2VkLWFk"),
      e("I2FkX2Jsb2NrZXI=")
    ],
    adGuardAnnoyances: [
      ".hs-sosyal",
      "#cookieconsentdiv",
      'div[class^="app_gdpr"]',
      ".as-oil",
      '[data-cypress="soft-push-notification-modal"]'
    ],
    adGuardBase: [
      ".BetterJsPopOverlay",
      e("I2FkXzMwMFgyNTA="),
      e("I2Jhbm5lcmZsb2F0MjI="),
      e("I2NhbXBhaWduLWJhbm5lcg=="),
      e("I0FkLUNvbnRlbnQ=")
    ],
    adGuardChinese: [
      e("LlppX2FkX2FfSA=="),
      e("YVtocmVmKj0iLmh0aGJldDM0LmNvbSJd"),
      "#widget-quan",
      e("YVtocmVmKj0iLzg0OTkyMDIwLnh5eiJd"),
      e("YVtocmVmKj0iLjE5NTZobC5jb20vIl0=")
    ],
    adGuardFrench: [
      "#pavePub",
      e("LmFkLWRlc2t0b3AtcmVjdGFuZ2xl"),
      ".mobile_adhesion",
      ".widgetadv",
      e("LmFkc19iYW4=")
    ],
    adGuardGerman: ['aside[data-portal-id="leaderboard"]'],
    adGuardJapanese: [
      "#kauli_yad_1",
      e("YVtocmVmXj0iaHR0cDovL2FkMi50cmFmZmljZ2F0ZS5uZXQvIl0="),
      e("Ll9wb3BJbl9pbmZpbml0ZV9hZA=="),
      e("LmFkZ29vZ2xl"),
      e("Ll9faXNib29zdFJldHVybkFk")
    ],
    adGuardMobile: [
      e("YW1wLWF1dG8tYWRz"),
      e("LmFtcF9hZA=="),
      'amp-embed[type="24smi"]',
      "#mgid_iframe1",
      e("I2FkX2ludmlld19hcmVh")
    ],
    adGuardRussian: [
      e("YVtocmVmXj0iaHR0cHM6Ly9hZC5sZXRtZWFkcy5jb20vIl0="),
      e("LnJlY2xhbWE="),
      'div[id^="smi2adblock"]',
      e("ZGl2W2lkXj0iQWRGb3hfYmFubmVyXyJd"),
      "#psyduckpockeball"
    ],
    adGuardSocial: [
      e("YVtocmVmXj0iLy93d3cuc3R1bWJsZXVwb24uY29tL3N1Ym1pdD91cmw9Il0="),
      e("YVtocmVmXj0iLy90ZWxlZ3JhbS5tZS9zaGFyZS91cmw/Il0="),
      ".etsy-tweet",
      "#inlineShare",
      ".popup-social"
    ],
    adGuardSpanishPortuguese: ["#barraPublicidade", "#Publicidade", "#publiEspecial", "#queTooltip", ".cnt-publi"],
    adGuardTrackingProtection: [
      "#qoo-counter",
      e("YVtocmVmXj0iaHR0cDovL2NsaWNrLmhvdGxvZy5ydS8iXQ=="),
      e("YVtocmVmXj0iaHR0cDovL2hpdGNvdW50ZXIucnUvdG9wL3N0YXQucGhwIl0="),
      e("YVtocmVmXj0iaHR0cDovL3RvcC5tYWlsLnJ1L2p1bXAiXQ=="),
      "#top100counter"
    ],
    adGuardTurkish: [
      "#backkapat",
      e("I3Jla2xhbWk="),
      e("YVtocmVmXj0iaHR0cDovL2Fkc2Vydi5vbnRlay5jb20udHIvIl0="),
      e("YVtocmVmXj0iaHR0cDovL2l6bGVuemkuY29tL2NhbXBhaWduLyJd"),
      e("YVtocmVmXj0iaHR0cDovL3d3dy5pbnN0YWxsYWRzLm5ldC8iXQ==")
    ],
    bulgarian: [e("dGQjZnJlZW5ldF90YWJsZV9hZHM="), "#ea_intext_div", ".lapni-pop-over", "#xenium_hot_offers"],
    easyList: [
      ".yb-floorad",
      e("LndpZGdldF9wb19hZHNfd2lkZ2V0"),
      e("LnRyYWZmaWNqdW5reS1hZA=="),
      ".textad_headline",
      e("LnNwb25zb3JlZC10ZXh0LWxpbmtz")
    ],
    easyListChina: [
      e("LmFwcGd1aWRlLXdyYXBbb25jbGljayo9ImJjZWJvcy5jb20iXQ=="),
      e("LmZyb250cGFnZUFkdk0="),
      "#taotaole",
      "#aafoot.top_box",
      ".cfa_popup"
    ],
    easyListCookie: [
      ".ezmob-footer",
      ".cc-CookieWarning",
      "[data-cookie-number]",
      e("LmF3LWNvb2tpZS1iYW5uZXI="),
      ".sygnal24-gdpr-modal-wrap"
    ],
    easyListCzechSlovak: [
      "#onlajny-stickers",
      e("I3Jla2xhbW5pLWJveA=="),
      e("LnJla2xhbWEtbWVnYWJvYXJk"),
      ".sklik",
      e("W2lkXj0ic2tsaWtSZWtsYW1hIl0=")
    ],
    easyListDutch: [
      e("I2FkdmVydGVudGll"),
      e("I3ZpcEFkbWFya3RCYW5uZXJCbG9jaw=="),
      ".adstekst",
      e("YVtocmVmXj0iaHR0cHM6Ly94bHR1YmUubmwvY2xpY2svIl0="),
      "#semilo-lrectangle"
    ],
    easyListGermany: [
      "#SSpotIMPopSlider",
      e("LnNwb25zb3JsaW5rZ3J1ZW4="),
      e("I3dlcmJ1bmdza3k="),
      e("I3Jla2xhbWUtcmVjaHRzLW1pdHRl"),
      e("YVtocmVmXj0iaHR0cHM6Ly9iZDc0Mi5jb20vIl0=")
    ],
    easyListItaly: [
      e("LmJveF9hZHZfYW5udW5jaQ=="),
      ".sb-box-pubbliredazionale",
      e("YVtocmVmXj0iaHR0cDovL2FmZmlsaWF6aW9uaWFkcy5zbmFpLml0LyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hZHNlcnZlci5odG1sLml0LyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hZmZpbGlhemlvbmlhZHMuc25haS5pdC8iXQ==")
    ],
    easyListLithuania: [
      e("LnJla2xhbW9zX3RhcnBhcw=="),
      e("LnJla2xhbW9zX251b3JvZG9z"),
      e("aW1nW2FsdD0iUmVrbGFtaW5pcyBza3lkZWxpcyJd"),
      e("aW1nW2FsdD0iRGVkaWt1b3RpLmx0IHNlcnZlcmlhaSJd"),
      e("aW1nW2FsdD0iSG9zdGluZ2FzIFNlcnZlcmlhaS5sdCJd")
    ],
    estonian: [e("QVtocmVmKj0iaHR0cDovL3BheTRyZXN1bHRzMjQuZXUiXQ==")],
    fanboyAnnoyances: ["#ac-lre-player", ".navigate-to-top", "#subscribe_popup", ".newsletter_holder", "#back-top"],
    fanboyAntiFacebook: [".util-bar-module-firefly-visible"],
    fanboyEnhancedTrackers: [
      ".open.pushModal",
      "#issuem-leaky-paywall-articles-zero-remaining-nag",
      "#sovrn_container",
      'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
      ".BlockNag__Card"
    ],
    fanboySocial: ["#FollowUs", "#meteored_share", "#social_follow", ".article-sharer", ".community__social-desc"],
    frellwitSwedish: [
      e("YVtocmVmKj0iY2FzaW5vcHJvLnNlIl1bdGFyZ2V0PSJfYmxhbmsiXQ=="),
      e("YVtocmVmKj0iZG9rdG9yLXNlLm9uZWxpbmsubWUiXQ=="),
      "article.category-samarbete",
      e("ZGl2LmhvbGlkQWRz"),
      "ul.adsmodern"
    ],
    greekAdBlock: [
      e("QVtocmVmKj0iYWRtYW4ub3RlbmV0LmdyL2NsaWNrPyJd"),
      e("QVtocmVmKj0iaHR0cDovL2F4aWFiYW5uZXJzLmV4b2R1cy5nci8iXQ=="),
      e("QVtocmVmKj0iaHR0cDovL2ludGVyYWN0aXZlLmZvcnRobmV0LmdyL2NsaWNrPyJd"),
      "DIV.agores300",
      "TABLE.advright"
    ],
    hungarian: [
      "#cemp_doboz",
      ".optimonk-iframe-container",
      e("LmFkX19tYWlu"),
      e("W2NsYXNzKj0iR29vZ2xlQWRzIl0="),
      "#hirdetesek_box"
    ],
    iDontCareAboutCookies: [
      '.alert-info[data-block-track*="CookieNotice"]',
      ".ModuleTemplateCookieIndicator",
      ".o--cookies--container",
      "#cookies-policy-sticky",
      "#stickyCookieBar"
    ],
    icelandicAbp: [e("QVtocmVmXj0iL2ZyYW1ld29yay9yZXNvdXJjZXMvZm9ybXMvYWRzLmFzcHgiXQ==")],
    latvian: [
      e("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiAxMjBweDsgaGVpZ2h0OiA0MHB4OyBvdmVyZmxvdzogaGlkZGVuOyBwb3NpdGlvbjogcmVsYXRpdmU7Il0="),
      e("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiA4OHB4OyBoZWlnaHQ6IDMxcHg7IG92ZXJmbG93OiBoaWRkZW47IHBvc2l0aW9uOiByZWxhdGl2ZTsiXQ==")
    ],
    listKr: [
      e("YVtocmVmKj0iLy9hZC5wbGFuYnBsdXMuY28ua3IvIl0="),
      e("I2xpdmVyZUFkV3JhcHBlcg=="),
      e("YVtocmVmKj0iLy9hZHYuaW1hZHJlcC5jby5rci8iXQ=="),
      e("aW5zLmZhc3R2aWV3LWFk"),
      ".revenue_unit_item.dable"
    ],
    listeAr: [
      e("LmdlbWluaUxCMUFk"),
      ".right-and-left-sponsers",
      e("YVtocmVmKj0iLmFmbGFtLmluZm8iXQ=="),
      e("YVtocmVmKj0iYm9vcmFxLm9yZyJd"),
      e("YVtocmVmKj0iZHViaXp6bGUuY29tL2FyLz91dG1fc291cmNlPSJd")
    ],
    listeFr: [
      e("YVtocmVmXj0iaHR0cDovL3Byb21vLnZhZG9yLmNvbS8iXQ=="),
      e("I2FkY29udGFpbmVyX3JlY2hlcmNoZQ=="),
      e("YVtocmVmKj0id2Vib3JhbWEuZnIvZmNnaS1iaW4vIl0="),
      ".site-pub-interstitiel",
      'div[id^="crt-"][data-criteo-id]'
    ],
    officialPolish: [
      "#ceneo-placeholder-ceneo-12",
      e("W2hyZWZePSJodHRwczovL2FmZi5zZW5kaHViLnBsLyJd"),
      e("YVtocmVmXj0iaHR0cDovL2Fkdm1hbmFnZXIudGVjaGZ1bi5wbC9yZWRpcmVjdC8iXQ=="),
      e("YVtocmVmXj0iaHR0cDovL3d3dy50cml6ZXIucGwvP3V0bV9zb3VyY2UiXQ=="),
      e("ZGl2I3NrYXBpZWNfYWQ=")
    ],
    ro: [
      e("YVtocmVmXj0iLy9hZmZ0cmsuYWx0ZXgucm8vQ291bnRlci9DbGljayJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9ibGFja2ZyaWRheXNhbGVzLnJvL3Ryay9zaG9wLyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9ldmVudC4ycGVyZm9ybWFudC5jb20vZXZlbnRzL2NsaWNrIl0="),
      e("YVtocmVmXj0iaHR0cHM6Ly9sLnByb2ZpdHNoYXJlLnJvLyJd"),
      'a[href^="/url/"]'
    ],
    ruAd: [
      e("YVtocmVmKj0iLy9mZWJyYXJlLnJ1LyJd"),
      e("YVtocmVmKj0iLy91dGltZy5ydS8iXQ=="),
      e("YVtocmVmKj0iOi8vY2hpa2lkaWtpLnJ1Il0="),
      "#pgeldiz",
      ".yandex-rtb-block"
    ],
    thaiAds: [
      "a[href*=macau-uta-popup]",
      e("I2Fkcy1nb29nbGUtbWlkZGxlX3JlY3RhbmdsZS1ncm91cA=="),
      e("LmFkczMwMHM="),
      ".bumq",
      ".img-kosana"
    ],
    webAnnoyancesUltralist: [
      "#mod-social-share-2",
      "#social-tools",
      e("LmN0cGwtZnVsbGJhbm5lcg=="),
      ".zergnet-recommend",
      ".yt.btn-link.btn-md.btn"
    ]
  };
}
function nu(e) {
  var t = e === void 0 ? {} : e, r = t.debug;
  return Le(this, void 0, void 0, function() {
    var n, o, a, s, i, m;
    return De(this, function(l) {
      switch (l.label) {
        case 0:
          return ou() ? (n = ru(), o = Object.keys(n), a = (m = []).concat.apply(m, o.map(function(f) {
            return n[f];
          })), [4, au(a)]) : [2, void 0];
        case 1:
          return s = l.sent(), r && iu(n, s), i = o.filter(function(f) {
            var b = n[f], c = xe(b.map(function(d) {
              return s[d];
            }));
            return c > b.length * 0.6;
          }), i.sort(), [2, i];
      }
    });
  });
}
function ou() {
  return it() || ua();
}
function au(e) {
  var t;
  return Le(this, void 0, void 0, function() {
    var r, n, o, a, m, s, i, m;
    return De(this, function(l) {
      switch (l.label) {
        case 0:
          for (r = document, n = r.createElement("div"), o = new Array(e.length), a = {}, Oo(n), m = 0; m < e.length; ++m)
            s = Ec(e[m]), s.tagName === "DIALOG" && s.show(), i = r.createElement("div"), Oo(i), i.appendChild(s), n.appendChild(i), o[m] = s;
          l.label = 1;
        case 1:
          return r.body ? [3, 3] : [4, ot(50)];
        case 2:
          return l.sent(), [3, 1];
        case 3:
          r.body.appendChild(n);
          try {
            for (m = 0; m < e.length; ++m)
              o[m].offsetParent || (a[e[m]] = !0);
          } finally {
            (t = n.parentNode) === null || t === void 0 || t.removeChild(n);
          }
          return [2, a];
      }
    });
  });
}
function Oo(e) {
  e.style.setProperty("display", "block", "important");
}
function iu(e, t) {
  for (var r = "DOM blockers debug:\n```", n = 0, o = Object.keys(e); n < o.length; n++) {
    var a = o[n];
    r += `
`.concat(a, ":");
    for (var s = 0, i = e[a]; s < i.length; s++) {
      var m = i[s];
      r += `
  `.concat(t[m] ? "🚫" : "➡️", " ").concat(m);
    }
  }
  console.log("".concat(r, "\n```"));
}
function cu() {
  for (var e = 0, t = ["rec2020", "p3", "srgb"]; e < t.length; e++) {
    var r = t[e];
    if (matchMedia("(color-gamut: ".concat(r, ")")).matches)
      return r;
  }
}
function uu() {
  if (_o("inverted"))
    return !0;
  if (_o("none"))
    return !1;
}
function _o(e) {
  return matchMedia("(inverted-colors: ".concat(e, ")")).matches;
}
function su() {
  if (To("active"))
    return !0;
  if (To("none"))
    return !1;
}
function To(e) {
  return matchMedia("(forced-colors: ".concat(e, ")")).matches;
}
var fu = 100;
function lu() {
  if (matchMedia("(min-monochrome: 0)").matches) {
    for (var e = 0; e <= fu; ++e)
      if (matchMedia("(max-monochrome: ".concat(e, ")")).matches)
        return e;
    throw new Error("Too high value");
  }
}
function pu() {
  if (He("no-preference"))
    return 0;
  if (He("high") || He("more"))
    return 1;
  if (He("low") || He("less"))
    return -1;
  if (He("forced"))
    return 10;
}
function He(e) {
  return matchMedia("(prefers-contrast: ".concat(e, ")")).matches;
}
function du() {
  if (Po("reduce"))
    return !0;
  if (Po("no-preference"))
    return !1;
}
function Po(e) {
  return matchMedia("(prefers-reduced-motion: ".concat(e, ")")).matches;
}
function yu() {
  if (Ao("high"))
    return !0;
  if (Ao("standard"))
    return !1;
}
function Ao(e) {
  return matchMedia("(dynamic-range: ".concat(e, ")")).matches;
}
var ce = Math, ge = function() {
  return 0;
};
function vu() {
  var e = ce.acos || ge, t = ce.acosh || ge, r = ce.asin || ge, n = ce.asinh || ge, o = ce.atanh || ge, a = ce.atan || ge, s = ce.sin || ge, i = ce.sinh || ge, m = ce.cos || ge, l = ce.cosh || ge, f = ce.tan || ge, b = ce.tanh || ge, c = ce.exp || ge, d = ce.expm1 || ge, v = ce.log1p || ge, u = function(A) {
    return ce.pow(ce.PI, A);
  }, y = function(A) {
    return ce.log(A + ce.sqrt(A * A - 1));
  }, S = function(A) {
    return ce.log(A + ce.sqrt(A * A + 1));
  }, w = function(A) {
    return ce.log((1 + A) / (1 - A)) / 2;
  }, h = function(A) {
    return ce.exp(A) - 1 / ce.exp(A) / 2;
  }, g = function(A) {
    return (ce.exp(A) + 1 / ce.exp(A)) / 2;
  }, p = function(A) {
    return ce.exp(A) - 1;
  }, P = function(A) {
    return (ce.exp(2 * A) - 1) / (ce.exp(2 * A) + 1);
  }, _ = function(A) {
    return ce.log(1 + A);
  };
  return {
    acos: e(0.12312423423423424),
    acosh: t(1e308),
    acoshPf: y(1e154),
    asin: r(0.12312423423423424),
    asinh: n(1),
    asinhPf: S(1),
    atanh: o(0.5),
    atanhPf: w(0.5),
    atan: a(0.5),
    sin: s(-1e300),
    sinh: i(1),
    sinhPf: h(1),
    cos: m(10.000000000123),
    cosh: l(1),
    coshPf: g(1),
    tan: f(-1e300),
    tanh: b(1),
    tanhPf: P(1),
    exp: c(1),
    expm1: d(1),
    expm1Pf: p(1),
    log1p: v(10),
    log1pPf: _(10),
    powPI: u(-100)
  };
}
var mu = "mmMwWLliI0fiflO&1", ar = {
  /**
   * The default font. User can change it in desktop Chrome, desktop Firefox, IE 11,
   * Android Chrome (but only when the size is ≥ than the default) and Android Firefox.
   */
  default: [],
  /** OS font on macOS. User can change its size and weight. Applies after Safari restart. */
  apple: [{ font: "-apple-system-body" }],
  /** User can change it in desktop Chrome and desktop Firefox. */
  serif: [{ fontFamily: "serif" }],
  /** User can change it in desktop Chrome and desktop Firefox. */
  sans: [{ fontFamily: "sans-serif" }],
  /** User can change it in desktop Chrome and desktop Firefox. */
  mono: [{ fontFamily: "monospace" }],
  /**
   * Check the smallest allowed font size. User can change it in desktop Chrome, desktop Firefox and desktop Safari.
   * The height can be 0 in Chrome on a retina display.
   */
  min: [{ fontSize: "1px" }],
  /** Tells one OS from another in desktop Chrome. */
  system: [{ fontFamily: "system-ui" }]
};
function bu() {
  return hu(function(e, t) {
    for (var r = {}, n = {}, o = 0, a = Object.keys(ar); o < a.length; o++) {
      var s = a[o], i = ar[s], m = i[0], l = m === void 0 ? {} : m, f = i[1], b = f === void 0 ? mu : f, c = e.createElement("span");
      c.textContent = b, c.style.whiteSpace = "nowrap";
      for (var d = 0, v = Object.keys(l); d < v.length; d++) {
        var u = v[d], y = l[u];
        y !== void 0 && (c.style[u] = y);
      }
      r[s] = c, t.appendChild(e.createElement("br")), t.appendChild(c);
    }
    for (var S = 0, w = Object.keys(ar); S < w.length; S++) {
      var s = w[S];
      n[s] = r[s].getBoundingClientRect().width;
    }
    return n;
  });
}
function hu(e, t) {
  return t === void 0 && (t = 4e3), sa(function(r, n) {
    var o = n.document, a = o.body, s = a.style;
    s.width = "".concat(t, "px"), s.webkitTextSizeAdjust = s.textSizeAdjust = "none", _r() ? a.style.zoom = "".concat(1 / n.devicePixelRatio) : it() && (a.style.zoom = "reset");
    var i = o.createElement("div");
    return i.textContent = Rr([], Array(t / 20 << 0), !0).map(function() {
      return "word";
    }).join(" "), a.appendChild(i), e(o, a);
  }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
}
function gu() {
  var e, t = document.createElement("canvas"), r = (e = t.getContext("webgl")) !== null && e !== void 0 ? e : t.getContext("experimental-webgl");
  if (r && "getExtension" in r) {
    var n = r.getExtension("WEBGL_debug_renderer_info");
    if (n)
      return {
        vendor: (r.getParameter(n.UNMASKED_VENDOR_WEBGL) || "").toString(),
        renderer: (r.getParameter(n.UNMASKED_RENDERER_WEBGL) || "").toString()
      };
  }
}
function wu() {
  return navigator.pdfViewerEnabled;
}
function Eu() {
  var e = new Float32Array(1), t = new Uint8Array(e.buffer);
  return e[0] = 1 / 0, e[0] = e[0] - e[0], t[3];
}
var Su = {
  // READ FIRST:
  // See https://github.com/fingerprintjs/fingerprintjs/blob/master/contributing.md#how-to-make-an-entropy-source
  // to learn how entropy source works and how to make your own.
  // The sources run in this exact order.
  // The asynchronous sources are at the start to run in parallel with other sources.
  fonts: _c,
  domBlockers: nu,
  fontPreferences: bu,
  audio: bc,
  screenFrame: Uc,
  osCpu: Ic,
  languages: Lc,
  colorDepth: Dc,
  deviceMemory: Fc,
  screenResolution: Nc,
  hardwareConcurrency: Bc,
  timezone: zc,
  sessionStorage: qc,
  localStorage: Hc,
  indexedDB: $c,
  openDatabase: Xc,
  cpuClass: Jc,
  platform: Kc,
  plugins: Tc,
  canvas: Pc,
  touchSupport: jc,
  vendor: Qc,
  vendorFlavors: eu,
  cookiesEnabled: tu,
  colorGamut: cu,
  invertedColors: uu,
  forcedColors: su,
  monochrome: lu,
  contrast: pu,
  reducedMotion: du,
  hdr: yu,
  math: vu,
  videoCard: gu,
  pdfViewerEnabled: wu,
  architecture: Eu
};
function Ru(e) {
  return sc(Su, e, []);
}
var Ou = "$ if upgrade to Pro: https://fpjs.dev/pro";
function _u(e) {
  var t = Tu(e), r = Pu(t);
  return { score: t, comment: Ou.replace(/\$/g, "".concat(r)) };
}
function Tu(e) {
  if (ua())
    return 0.4;
  if (it())
    return Tr() ? 0.5 : 0.3;
  var t = e.platform.value || "";
  return /^Win/.test(t) ? 0.6 : /^Mac/.test(t) ? 0.5 : 0.7;
}
function Pu(e) {
  return ia(0.99 + 0.01 * e, 1e-4);
}
function Au(e) {
  for (var t = "", r = 0, n = Object.keys(e).sort(); r < n.length; r++) {
    var o = n[r], a = e[o], s = a.error ? "error" : JSON.stringify(a.value);
    t += "".concat(t ? "|" : "").concat(o.replace(/([:|\\])/g, "\\$1"), ":").concat(s);
  }
  return t;
}
function fa(e) {
  return JSON.stringify(e, function(t, r) {
    return r instanceof Error ? nc(r) : r;
  }, 2);
}
function la(e) {
  return rc(Au(e));
}
function Cu(e) {
  var t, r = _u(e);
  return {
    get visitorId() {
      return t === void 0 && (t = la(this.components)), t;
    },
    set visitorId(n) {
      t = n;
    },
    confidence: r,
    components: e,
    version: oa
  };
}
function xu(e) {
  return e === void 0 && (e = 50), tc(e, e * 2);
}
function ku(e, t) {
  var r = Date.now();
  return {
    get: function(n) {
      return Le(this, void 0, void 0, function() {
        var o, a, s;
        return De(this, function(i) {
          switch (i.label) {
            case 0:
              return o = Date.now(), [4, e()];
            case 1:
              return a = i.sent(), s = Cu(a), (t || n != null && n.debug) && console.log("Copy the text below to get the debug data:\n\n```\nversion: ".concat(s.version, `
userAgent: `).concat(navigator.userAgent, `
timeBetweenLoadAndGet: `).concat(o - r, `
visitorId: `).concat(s.visitorId, `
components: `).concat(fa(a), "\n```")), [2, s];
          }
        });
      });
    }
  };
}
function Mu() {
  if (!(window.__fpjs_d_m || Math.random() >= 1e-3))
    try {
      var e = new XMLHttpRequest();
      e.open("get", "https://m1.openfpcdn.io/fingerprintjs/v".concat(oa, "/npm-monitoring"), !0), e.send();
    } catch (t) {
      console.error(t);
    }
}
function ju(e) {
  var t = e === void 0 ? {} : e, r = t.delayFallback, n = t.debug, o = t.monitoring, a = o === void 0 ? !0 : o;
  return Le(this, void 0, void 0, function() {
    var s;
    return De(this, function(i) {
      switch (i.label) {
        case 0:
          return a && Mu(), [4, xu(r)];
        case 1:
          return i.sent(), s = Ru({ debug: n }), [2, ku(s, n)];
      }
    });
  });
}
var Iu = { load: ju, hashComponents: la, componentsToDebugString: fa };
function Lu(e, t) {
  return function(r, n) {
    return Object.prototype.hasOwnProperty.call(r, n);
  }(e, t) ? e[t] : void 0;
}
function Qe(e) {
  for (var t = "", r = 0; r < e.length; ++r)
    if (r > 0) {
      var n = e[r].toLowerCase();
      n !== e[r] ? t += " ".concat(n) : t += e[r];
    } else
      t += e[r].toUpperCase();
  return t;
}
var Du = { default: "endpoint" }, Fu = { default: "tlsEndpoint" }, Nu = "Client timeout", Vu = "Network connection error", Wu = "Network request aborted", Yu = "Response cannot be parsed", Pr = "Blocked by CSP", Gu = /* @__PURE__ */ Qe("WrongRegion"), Uu = /* @__PURE__ */ Qe("SubscriptionNotActive"), Bu = /* @__PURE__ */ Qe("UnsupportedVersion"), zu = /* @__PURE__ */ Qe("InstallationMethodRestricted"), Zu = /* @__PURE__ */ Qe("HostnameRestricted"), qu = /* @__PURE__ */ Qe("IntegrationFailed"), Ar = "API key required", pa = "API key not found", da = "API key expired", Hu = "Request cannot be parsed", $u = "Request failed", Xu = "Request failed to process", Ju = "Too many requests, rate limit exceeded", Ku = "Not available for this origin", Qu = "Not available with restricted header", es = Ar, ts = pa, rs = da, ns = "3.8.2", Cr = "9319";
function os(e, t) {
  var r = [];
  return function(n, o) {
    var a = 5, s = (c = n, d = Rr([], c, !0), { current: function() {
      return d[0];
    }, postpone: function() {
      var u = d.shift();
      u !== void 0 && d.push(u);
    }, exclude: function() {
      d.shift();
    } }), i = (l = 100, f = 3e3, b = 0, function() {
      return Math.random() * Math.min(f, l * Math.pow(2, b++));
    }), m = s.current(), l, f, b, c, d;
    if (m === void 0)
      return Promise.reject(new TypeError("The list of script URL patterns is empty"));
    var v = function(u, y) {
      return o(u).catch(function(S) {
        if (y + 1 >= a)
          throw S;
        (function(g) {
          if (!(g instanceof Error))
            return !1;
          var p = g.message;
          return p === Pr || p === Cr;
        })(S) ? s.exclude() : s.postpone();
        var w, h = s.current();
        if (h === void 0)
          throw S;
        return (w = i(), new Promise(function(g) {
          return setTimeout(g, w);
        })).then(function() {
          return v(h, y + 1);
        });
      });
    };
    return v(m, 0);
  }(e, function(n) {
    var o = /* @__PURE__ */ new Date(), a = function() {
      return r.push({ url: n, startedAt: o, finishedAt: /* @__PURE__ */ new Date() });
    }, s = t(n);
    return s.then(a, a), s;
  }).then(function(n) {
    return [n, { attempts: r }];
  });
}
var ya = "https://fpnpmcdn.net/v<version>/<apiKey>/loader_v<loaderVersion>.js", as = ya, xr = "Failed to load the JS script of the agent";
function is(e) {
  var t;
  e.scriptUrlPattern;
  var r = e.token, n = e.apiKey, o = n === void 0 ? r : n, a = ec(e, ["scriptUrlPattern", "token", "apiKey"]), s = (t = Lu(e, "scriptUrlPattern")) !== null && t !== void 0 ? t : ya;
  return Promise.resolve().then(function() {
    if (!o || typeof o != "string")
      throw new Error(Ar);
    var i = function(m, l) {
      return (Array.isArray(m) ? m : [m]).map(function(f) {
        return function(b, c) {
          var d = encodeURIComponent;
          return b.replace(/<[^<>]+>/g, function(v) {
            return v === "<version>" ? "3" : v === "<apiKey>" ? d(c) : v === "<loaderVersion>" ? d(ns) : v;
          });
        }(String(f), l);
      });
    }(s, o);
    return os(i, cs).catch(ss);
  }).then(function(i) {
    var m = i[0], l = i[1];
    return m.load(nt(nt({}, a), { ldi: l }));
  });
}
function cs(e) {
  return function(t, r, n, o) {
    var a, s = document, i = "securitypolicyviolation", m = function(f) {
      var b = new URL(t, location.href), c = f.blockedURI;
      c !== b.href && c !== b.protocol.slice(0, -1) && c !== b.origin || (a = f, l());
    };
    s.addEventListener(i, m);
    var l = function() {
      return s.removeEventListener(i, m);
    };
    return o == null || o.then(l, l), Promise.resolve().then(r).then(function(f) {
      return l(), f;
    }, function(f) {
      return new Promise(function(b) {
        return setTimeout(b);
      }).then(function() {
        if (l(), a)
          return n(a);
        throw f;
      });
    });
  }(e, function() {
    return function(t) {
      return new Promise(function(r, n) {
        var o = document.createElement("script"), a = function() {
          var i;
          return (i = o.parentNode) === null || i === void 0 ? void 0 : i.removeChild(o);
        }, s = document.head || document.getElementsByTagName("head")[0];
        o.onload = function() {
          a(), r();
        }, o.onerror = function() {
          a(), n(new Error(xr));
        }, o.async = !0, o.src = t, s.appendChild(o);
      });
    }(e);
  }, function() {
    throw new Error(Pr);
  }).then(us);
}
function us() {
  var e = window, t = "__fpjs_p_l_b", r = e[t];
  if (function(n, o) {
    var a, s = (a = Object.getOwnPropertyDescriptor) === null || a === void 0 ? void 0 : a.call(Object, n, o);
    s != null && s.configurable ? delete n[o] : s && !s.writable || (n[o] = void 0);
  }(e, t), typeof (r == null ? void 0 : r.load) != "function")
    throw new Error(Cr);
  return r;
}
function ss(e) {
  throw e instanceof Error && e.message === Cr ? new Error(xr) : e;
}
var fs = { load: is, defaultScriptUrlPattern: as, ERROR_SCRIPT_LOAD_FAIL: xr, ERROR_API_KEY_EXPIRED: da, ERROR_API_KEY_INVALID: pa, ERROR_API_KEY_MISSING: Ar, ERROR_BAD_REQUEST_FORMAT: Hu, ERROR_BAD_RESPONSE_FORMAT: Yu, ERROR_CLIENT_TIMEOUT: Nu, ERROR_CSP_BLOCK: Pr, ERROR_FORBIDDEN_ENDPOINT: Zu, ERROR_FORBIDDEN_HEADER: Qu, ERROR_FORBIDDEN_ORIGIN: Ku, ERROR_GENERAL_SERVER_FAILURE: $u, ERROR_INSTALLATION_METHOD_RESTRICTED: zu, ERROR_INTEGRATION_FAILURE: qu, ERROR_NETWORK_ABORT: Wu, ERROR_NETWORK_CONNECTION: Vu, ERROR_RATE_LIMIT: Ju, ERROR_SERVER_TIMEOUT: Xu, ERROR_SUBSCRIPTION_NOT_ACTIVE: Uu, ERROR_TOKEN_EXPIRED: rs, ERROR_TOKEN_INVALID: ts, ERROR_TOKEN_MISSING: es, ERROR_UNSUPPORTED_VERSION: Bu, ERROR_WRONG_REGION: Gu, defaultEndpoint: Du, defaultTlsEndpoint: Fu };
const ls = "/", Co = (e, t, r = {}) => {
  const n = { ...r, path: r.path || ls }, { expires: o } = n;
  if (typeof o == "number" && o) {
    const s = /* @__PURE__ */ new Date();
    s.setTime(s.getTime() + o * 1e3), n.expires = s.toUTCString();
  }
  const a = encodeURIComponent(t);
  document.cookie = Object.entries(n).reduce((s, [i, m]) => {
    const l = m === !0 ? "" : `=${m}`;
    return `${s}; ${i}${l}`;
  }, `${e}=${a}`);
}, ps = (e) => {
  const t = document.cookie.match(`(^|;) ?${e}=([^;]*)(;|$)`);
  return t ? unescape(t[2]) : null;
}, xo = () => {
  let e = window.location.hostname;
  if (e === "localhost" || e.includes("127.0.0.1"))
    return e;
  const t = e.split("."), r = t.length;
  return r > 2 && (e = t[r - 2] + "." + t[r - 1], t[r - 2].length == 2 && t[r - 1].length == 2 && (e = t[r - 3] + "." + e)), e;
}, ir = "fp_device_id", lt = /* @__PURE__ */ new Date();
lt.setFullYear(lt.getFullYear() + 5);
const ds = async (e = "") => {
  const t = ps(ir);
  if (t)
    return t;
  try {
    const r = await fs.load({ apiKey: e }), { visitorId: n } = await r.get();
    return Co(ir, n, { domain: xo(), expires: lt, path: "/" }), n;
  } catch {
    const r = await Iu.load(), { visitorId: n } = await r.get(), o = `fallback_${n}`;
    return Co(ir, o, { domain: xo(), expires: lt, path: "/" }), o;
  }
};
var pr = { exports: {} };
(function(e, t) {
  (function(r, n) {
    var o = "1.0.35", a = "", s = "?", i = "function", m = "undefined", l = "object", f = "string", b = "major", c = "model", d = "name", v = "type", u = "vendor", y = "version", S = "architecture", w = "console", h = "mobile", g = "tablet", p = "smarttv", P = "wearable", _ = "embedded", A = 350, Y = "Amazon", q = "Apple", X = "ASUS", J = "BlackBerry", H = "Browser", Z = "Chrome", K = "Edge", j = "Firefox", ue = "Google", se = "Huawei", ve = "LG", T = "Microsoft", C = "Motorola", F = "Opera", M = "Samsung", L = "Sharp", V = "Sony", D = "Xiaomi", I = "Zebra", G = "Facebook", x = "Chromium OS", k = "Mac OS", N = function(z, Q) {
      var U = {};
      for (var ee in z)
        Q[ee] && Q[ee].length % 2 === 0 ? U[ee] = Q[ee].concat(z[ee]) : U[ee] = z[ee];
      return U;
    }, R = function(z) {
      for (var Q = {}, U = 0; U < z.length; U++)
        Q[z[U].toUpperCase()] = z[U];
      return Q;
    }, $ = function(z, Q) {
      return typeof z === f ? pe(Q).indexOf(pe(z)) !== -1 : !1;
    }, pe = function(z) {
      return z.toLowerCase();
    }, de = function(z) {
      return typeof z === f ? z.replace(/[^\d\.]/g, a).split(".")[0] : n;
    }, me = function(z, Q) {
      if (typeof z === f)
        return z = z.replace(/^\s\s*/, a), typeof Q === m ? z : z.substring(0, A);
    }, be = function(z, Q) {
      for (var U = 0, ee, Te, Re, te, W, Ee; U < Q.length && !W; ) {
        var Fe = Q[U], E = Q[U + 1];
        for (ee = Te = 0; ee < Fe.length && !W && Fe[ee]; )
          if (W = Fe[ee++].exec(z), W)
            for (Re = 0; Re < E.length; Re++)
              Ee = W[++Te], te = E[Re], typeof te === l && te.length > 0 ? te.length === 2 ? typeof te[1] == i ? this[te[0]] = te[1].call(this, Ee) : this[te[0]] = te[1] : te.length === 3 ? typeof te[1] === i && !(te[1].exec && te[1].test) ? this[te[0]] = Ee ? te[1].call(this, Ee, te[2]) : n : this[te[0]] = Ee ? Ee.replace(te[1], te[2]) : n : te.length === 4 && (this[te[0]] = Ee ? te[3].call(this, Ee.replace(te[1], te[2])) : n) : this[te] = Ee || n;
        U += 2;
      }
    }, ke = function(z, Q) {
      for (var U in Q)
        if (typeof Q[U] === l && Q[U].length > 0) {
          for (var ee = 0; ee < Q[U].length; ee++)
            if ($(Q[U][ee], z))
              return U === s ? n : U;
        } else if ($(Q[U], z))
          return U === s ? n : U;
      return z;
    }, Me = {
      "1.0": "/8",
      "1.2": "/1",
      "1.3": "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, we = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2e3: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      "8.1": "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    }, je = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
          // Chrome for Android/iOS
        ],
        [y, [d, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
          // Microsoft Edge
        ],
        [y, [d, "Edge"]],
        [
          // Presto based
          /(opera mini)\/([-\w\.]+)/i,
          // Opera Mini
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          // Opera Mobi/Tablet
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
          // Opera
        ],
        [d, y],
        [
          /opios[\/ ]+([\w\.]+)/i
          // Opera mini on iphone >= 8.0
        ],
        [y, [d, F + " Mini"]],
        [
          /\bopr\/([\w\.]+)/i
          // Opera Webkit
        ],
        [y, [d, F]],
        [
          // Mixed
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
          // Lunascape/Maxthon/Netfront/Jasmine/Blazer
          // Trident based
          /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
          // Avant/IEMobile/SlimBrowser
          /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
          // Baidu Browser
          /(?:ms|\()(ie) ([\w\.]+)/i,
          // Internet Explorer
          // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
          /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
          // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
          /(heytap|ovi)browser\/([\d\.]+)/i,
          // Heytap/Ovi
          /(weibo)__([\d\.]+)/i
          // Weibo
        ],
        [d, y],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
          // UCBrowser
        ],
        [y, [d, "UC" + H]],
        [
          /microm.+\bqbcore\/([\w\.]+)/i,
          // WeChat Desktop for Windows Built-in Browser
          /\bqbcore\/([\w\.]+).+microm/i
        ],
        [y, [d, "WeChat(Win) Desktop"]],
        [
          /micromessenger\/([\w\.]+)/i
          // WeChat
        ],
        [y, [d, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
          // Konqueror
        ],
        [y, [d, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
          // IE11
        ],
        [y, [d, "IE"]],
        [
          /ya(?:search)?browser\/([\w\.]+)/i
          // Yandex
        ],
        [y, [d, "Yandex"]],
        [
          /(avast|avg)\/([\w\.]+)/i
          // Avast/AVG Secure Browser
        ],
        [[d, /(.+)/, "$1 Secure " + H], y],
        [
          /\bfocus\/([\w\.]+)/i
          // Firefox Focus
        ],
        [y, [d, j + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
          // Opera Touch
        ],
        [y, [d, F + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
          // Coc Coc Browser
        ],
        [y, [d, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
          // Dolphin
        ],
        [y, [d, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
          // Opera Coast
        ],
        [y, [d, F + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
          // MIUI Browser
        ],
        [y, [d, "MIUI " + H]],
        [
          /fxios\/([-\w\.]+)/i
          // Firefox for iOS
        ],
        [y, [d, j]],
        [
          /\bqihu|(qi?ho?o?|360)browser/i
          // 360
        ],
        [[d, "360 " + H]],
        [
          /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
        ],
        [[d, /(.+)/, "$1 " + H], y],
        [
          // Oculus/Samsung/Sailfish/Huawei Browser
          /(comodo_dragon)\/([\w\.]+)/i
          // Comodo Dragon
        ],
        [[d, /_/g, " "], y],
        [
          /(electron)\/([\w\.]+) safari/i,
          // Electron-based App
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          // Tesla
          /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
          // QQBrowser/Baidu App/2345 Browser
        ],
        [d, y],
        [
          /(metasr)[\/ ]?([\w\.]+)/i,
          // SouGouBrowser
          /(lbbrowser)/i,
          // LieBao Browser
          /\[(linkedin)app\]/i
          // LinkedIn App for iOS & Android
        ],
        [d],
        [
          // WebView
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
          // Facebook App for iOS & Android
        ],
        [[d, G], y],
        [
          /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
          // Kakao App
          /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
          // Naver InApp
          /safari (line)\/([\w\.]+)/i,
          // Line App for iOS
          /\b(line)\/([\w\.]+)\/iab/i,
          // Line App for Android
          /(chromium|instagram)[\/ ]([-\w\.]+)/i
          // Chromium/Instagram
        ],
        [d, y],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
          // Google Search Appliance on iOS
        ],
        [y, [d, "GSA"]],
        [
          /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
          // TikTok
        ],
        [y, [d, "TikTok"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
          // Chrome Headless
        ],
        [y, [d, Z + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
          // Chrome WebView
        ],
        [[d, Z + " WebView"], y],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
          // Android Browser
        ],
        [y, [d, "Android " + H]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
          // Chrome/OmniWeb/Arora/Tizen/Nokia
        ],
        [d, y],
        [
          /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
          // Mobile Safari
        ],
        [y, [d, "Mobile Safari"]],
        [
          /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
          // Safari & Safari Mobile
        ],
        [y, d],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
          // Safari < 3.0
        ],
        [d, [y, ke, Me]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [d, y],
        [
          // Gecko based
          /(navigator|netscape\d?)\/([-\w\.]+)/i
          // Netscape
        ],
        [[d, "Netscape"], y],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
          // Firefox Reality
        ],
        [y, [d, j + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          // Flow
          /(swiftfox)/i,
          // Swiftfox
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
          // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
          /(firefox)\/([\w\.]+)/i,
          // Other Firefox-based
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          // Mozilla
          // Other
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
          /(links) \(([\w\.]+)/i,
          // Links
          /panasonic;(viera)/i
          // Panasonic Viera
        ],
        [d, y],
        [
          /(cobalt)\/([\w\.]+)/i
          // Cobalt
        ],
        [d, [y, /master.|lts./, ""]]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
          // AMD64 (x64)
        ],
        [[S, "amd64"]],
        [
          /(ia32(?=;))/i
          // IA32 (quicktime)
        ],
        [[S, pe]],
        [
          /((?:i[346]|x)86)[;\)]/i
          // IA32 (x86)
        ],
        [[S, "ia32"]],
        [
          /\b(aarch64|arm(v?8e?l?|_?64))\b/i
          // ARM64
        ],
        [[S, "arm64"]],
        [
          /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
          // ARMHF
        ],
        [[S, "armhf"]],
        [
          // PocketPC mistakenly identified as PowerPC
          /windows (ce|mobile); ppc;/i
        ],
        [[S, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
          // PowerPC
        ],
        [[S, /ower/, a, pe]],
        [
          /(sun4\w)[;\)]/i
          // SPARC
        ],
        [[S, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
          // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ],
        [[S, pe]]
      ],
      device: [
        [
          //////////////////////////
          // MOBILES & TABLETS
          /////////////////////////
          // Samsung
          /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [c, [u, M], [v, g]],
        [
          /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
          /samsung[- ]([-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [c, [u, M], [v, h]],
        [
          // Apple
          /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
          // iPod/iPhone
        ],
        [c, [u, q], [v, h]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          // iPad
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [c, [u, q], [v, g]],
        [
          /(macintosh);/i
        ],
        [c, [u, q]],
        [
          // Sharp
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [c, [u, L], [v, h]],
        [
          // Huawei
          /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
        ],
        [c, [u, se], [v, g]],
        [
          /(?:huawei|honor)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [c, [u, se], [v, h]],
        [
          // Xiaomi
          /\b(poco[\w ]+)(?: bui|\))/i,
          // Xiaomi POCO
          /\b; (\w+) build\/hm\1/i,
          // Xiaomi Hongmi 'numeric' models
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          // Xiaomi Hongmi
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          // Xiaomi Redmi
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
          // Xiaomi Mi
        ],
        [[c, /_/g, " "], [u, D], [v, h]],
        [
          /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
          // Mi Pad tablets
        ],
        [[c, /_/g, " "], [u, D], [v, g]],
        [
          // OPPO
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [c, [u, "OPPO"], [v, h]],
        [
          // Vivo
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [c, [u, "Vivo"], [v, h]],
        [
          // Realme
          /\b(rmx[12]\d{3})(?: bui|;|\))/i
        ],
        [c, [u, "Realme"], [v, h]],
        [
          // Motorola
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [c, [u, C], [v, h]],
        [
          /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [c, [u, C], [v, g]],
        [
          // LG
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [c, [u, ve], [v, g]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [c, [u, ve], [v, h]],
        [
          // Lenovo
          /(ideatab[-\w ]+)/i,
          /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [c, [u, "Lenovo"], [v, g]],
        [
          // Nokia
          /(?:maemo|nokia).*(n900|lumia \d+)/i,
          /nokia[-_ ]?([-\w\.]*)/i
        ],
        [[c, /_/g, " "], [u, "Nokia"], [v, h]],
        [
          // Google
          /(pixel c)\b/i
          // Google Pixel C
        ],
        [c, [u, ue], [v, g]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
          // Google Pixel
        ],
        [c, [u, ue], [v, h]],
        [
          // Sony
          /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [c, [u, V], [v, h]],
        [
          /sony tablet [ps]/i,
          /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [[c, "Xperia Tablet"], [u, V], [v, g]],
        [
          // OnePlus
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [c, [u, "OnePlus"], [v, h]],
        [
          // Amazon
          /(alexa)webm/i,
          /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
          // Kindle Fire without Silk / Echo Show
          /(kf[a-z]+)( bui|\)).+silk\//i
          // Kindle Fire HD
        ],
        [c, [u, Y], [v, g]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
          // Fire Phone
        ],
        [[c, /(.+)/g, "Fire Phone $1"], [u, Y], [v, h]],
        [
          // BlackBerry
          /(playbook);[-\w\),; ]+(rim)/i
          // BlackBerry PlayBook
        ],
        [c, u, [v, g]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
          // BlackBerry 10
        ],
        [c, [u, J], [v, h]],
        [
          // Asus
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [c, [u, X], [v, g]],
        [
          / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [c, [u, X], [v, h]],
        [
          // HTC
          /(nexus 9)/i
          // HTC Nexus 9
        ],
        [c, [u, "HTC"], [v, g]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          // HTC
          // ZTE
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
          // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ],
        [u, [c, /_/g, " "], [v, h]],
        [
          // Acer
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [c, [u, "Acer"], [v, g]],
        [
          // Meizu
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [c, [u, "Meizu"], [v, h]],
        [
          // MIXED
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
          // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
          /(hp) ([\w ]+\w)/i,
          // HP iPAQ
          /(asus)-?(\w+)/i,
          // Asus
          /(microsoft); (lumia[\w ]+)/i,
          // Microsoft Lumia
          /(lenovo)[-_ ]?([-\w]+)/i,
          // Lenovo
          /(jolla)/i,
          // Jolla
          /(oppo) ?([\w ]+) bui/i
          // OPPO
        ],
        [u, c, [v, h]],
        [
          /(kobo)\s(ereader|touch)/i,
          // Kobo
          /(archos) (gamepad2?)/i,
          // Archos
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          // HP TouchPad
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(nook)[\w ]+build\/(\w+)/i,
          // Nook
          /(dell) (strea[kpr\d ]*[\dko])/i,
          // Dell Streak
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          // Le Pan Tablets
          /(trinity)[- ]*(t\d{3}) bui/i,
          // Trinity Tablets
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          // Gigaset Tablets
          /(vodafone) ([\w ]+)(?:\)| bui)/i
          // Vodafone
        ],
        [u, c, [v, g]],
        [
          /(surface duo)/i
          // Surface Duo
        ],
        [c, [u, T], [v, g]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
          // Fairphone
        ],
        [c, [u, "Fairphone"], [v, h]],
        [
          /(u304aa)/i
          // AT&T
        ],
        [c, [u, "AT&T"], [v, h]],
        [
          /\bsie-(\w*)/i
          // Siemens
        ],
        [c, [u, "Siemens"], [v, h]],
        [
          /\b(rct\w+) b/i
          // RCA Tablets
        ],
        [c, [u, "RCA"], [v, g]],
        [
          /\b(venue[\d ]{2,7}) b/i
          // Dell Venue Tablets
        ],
        [c, [u, "Dell"], [v, g]],
        [
          /\b(q(?:mv|ta)\w+) b/i
          // Verizon Tablet
        ],
        [c, [u, "Verizon"], [v, g]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
          // Barnes & Noble Tablet
        ],
        [c, [u, "Barnes & Noble"], [v, g]],
        [
          /\b(tm\d{3}\w+) b/i
        ],
        [c, [u, "NuVision"], [v, g]],
        [
          /\b(k88) b/i
          // ZTE K Series Tablet
        ],
        [c, [u, "ZTE"], [v, g]],
        [
          /\b(nx\d{3}j) b/i
          // ZTE Nubia
        ],
        [c, [u, "ZTE"], [v, h]],
        [
          /\b(gen\d{3}) b.+49h/i
          // Swiss GEN Mobile
        ],
        [c, [u, "Swiss"], [v, h]],
        [
          /\b(zur\d{3}) b/i
          // Swiss ZUR Tablet
        ],
        [c, [u, "Swiss"], [v, g]],
        [
          /\b((zeki)?tb.*\b) b/i
          // Zeki Tablets
        ],
        [c, [u, "Zeki"], [v, g]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
          // Dragon Touch Tablet
        ],
        [[u, "Dragon Touch"], c, [v, g]],
        [
          /\b(ns-?\w{0,9}) b/i
          // Insignia Tablets
        ],
        [c, [u, "Insignia"], [v, g]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
          // NextBook Tablets
        ],
        [c, [u, "NextBook"], [v, g]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
          // Voice Xtreme Phones
        ],
        [[u, "Voice"], c, [v, h]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
          // LvTel Phones
        ],
        [[u, "LvTel"], c, [v, h]],
        [
          /\b(ph-1) /i
          // Essential PH-1
        ],
        [c, [u, "Essential"], [v, h]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
          // Envizen Tablets
        ],
        [c, [u, "Envizen"], [v, g]],
        [
          /\b(trio[-\w\. ]+) b/i
          // MachSpeed Tablets
        ],
        [c, [u, "MachSpeed"], [v, g]],
        [
          /\btu_(1491) b/i
          // Rotor Tablets
        ],
        [c, [u, "Rotor"], [v, g]],
        [
          /(shield[\w ]+) b/i
          // Nvidia Shield Tablets
        ],
        [c, [u, "Nvidia"], [v, g]],
        [
          /(sprint) (\w+)/i
          // Sprint Phones
        ],
        [u, c, [v, h]],
        [
          /(kin\.[onetw]{3})/i
          // Microsoft Kin
        ],
        [[c, /\./g, " "], [u, T], [v, h]],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
          // Zebra
        ],
        [c, [u, I], [v, g]],
        [
          /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [c, [u, I], [v, h]],
        [
          ///////////////////
          // SMARTTVS
          ///////////////////
          /smart-tv.+(samsung)/i
          // Samsung
        ],
        [u, [v, p]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[c, /^/, "SmartTV"], [u, M], [v, p]],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
          // LG SmartTV
        ],
        [[u, ve], [v, p]],
        [
          /(apple) ?tv/i
          // Apple TV
        ],
        [u, [c, q + " TV"], [v, p]],
        [
          /crkey/i
          // Google Chromecast
        ],
        [[c, Z + "cast"], [u, ue], [v, p]],
        [
          /droid.+aft(\w)( bui|\))/i
          // Fire TV
        ],
        [c, [u, Y], [v, p]],
        [
          /\(dtv[\);].+(aquos)/i,
          /(aquos-tv[\w ]+)\)/i
          // Sharp
        ],
        [c, [u, L], [v, p]],
        [
          /(bravia[\w ]+)( bui|\))/i
          // Sony
        ],
        [c, [u, V], [v, p]],
        [
          /(mitv-\w{5}) bui/i
          // Xiaomi
        ],
        [c, [u, D], [v, p]],
        [
          /Hbbtv.*(technisat) (.*);/i
          // TechniSAT
        ],
        [u, c, [v, p]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          // Roku
          /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
          // HbbTV devices
        ],
        [[u, me], [c, me], [v, p]],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          // SmartTV from Unidentified Vendors
        ],
        [[v, p]],
        [
          ///////////////////
          // CONSOLES
          ///////////////////
          /(ouya)/i,
          // Ouya
          /(nintendo) ([wids3utch]+)/i
          // Nintendo
        ],
        [u, c, [v, w]],
        [
          /droid.+; (shield) bui/i
          // Nvidia
        ],
        [c, [u, "Nvidia"], [v, w]],
        [
          /(playstation [345portablevi]+)/i
          // Playstation
        ],
        [c, [u, V], [v, w]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
          // Microsoft Xbox
        ],
        [c, [u, T], [v, w]],
        [
          ///////////////////
          // WEARABLES
          ///////////////////
          /((pebble))app/i
          // Pebble
        ],
        [u, c, [v, P]],
        [
          /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
          // Apple Watch
        ],
        [c, [u, q], [v, P]],
        [
          /droid.+; (glass) \d/i
          // Google Glass
        ],
        [c, [u, ue], [v, P]],
        [
          /droid.+; (wt63?0{2,3})\)/i
        ],
        [c, [u, I], [v, P]],
        [
          /(quest( 2| pro)?)/i
          // Oculus Quest
        ],
        [c, [u, G], [v, P]],
        [
          ///////////////////
          // EMBEDDED
          ///////////////////
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
          // Tesla
        ],
        [u, [v, _]],
        [
          /(aeobc)\b/i
          // Echo Dot
        ],
        [c, [u, Y], [v, _]],
        [
          ////////////////////
          // MIXED (GENERIC)
          ///////////////////
          /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
          // Android Phones from Unidentified Vendors
        ],
        [c, [v, h]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
          // Android Tablets from Unidentified Vendors
        ],
        [c, [v, g]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
          // Unidentifiable Tablet
        ],
        [[v, g]],
        [
          /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
          // Unidentifiable Mobile
        ],
        [[v, h]],
        [
          /(android[-\w\. ]{0,9});.+buil/i
          // Generic Android Device
        ],
        [c, [u, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
          // EdgeHTML
        ],
        [y, [d, K + "HTML"]],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
          // Blink
        ],
        [y, [d, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          // Presto
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
          /ekioh(flow)\/([\w\.]+)/i,
          // Flow
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          // KHTML/Tasman/Links
          /(icab)[\/ ]([23]\.[\d\.]+)/i,
          // iCab
          /\b(libweb)/i
        ],
        [d, y],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
          // Gecko
        ],
        [y, d]
      ],
      os: [
        [
          // Windows
          /microsoft (windows) (vista|xp)/i
          // Windows (iTunes)
        ],
        [d, y],
        [
          /(windows) nt 6\.2; (arm)/i,
          // Windows RT
          /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
          // Windows Phone
          /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
        ],
        [d, [y, ke, we]],
        [
          /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [[d, "Windows"], [y, ke, we]],
        [
          // iOS/macOS
          /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
          // iOS
          /ios;fbsv\/([\d\.]+)/i,
          /cfnetwork\/.+darwin/i
        ],
        [[y, /_/g, "."], [d, "iOS"]],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
          // Mac OS
        ],
        [[d, k], [y, /_/g, "."]],
        [
          // Mobile OSes
          /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
          // Android-x86/HarmonyOS
        ],
        [y, d],
        [
          // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
          /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
          /(blackberry)\w*\/([\w\.]*)/i,
          // Blackberry
          /(tizen|kaios)[\/ ]([\w\.]+)/i,
          // Tizen/KaiOS
          /\((series40);/i
          // Series 40
        ],
        [d, y],
        [
          /\(bb(10);/i
          // BlackBerry 10
        ],
        [y, [d, J]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
          // Symbian
        ],
        [y, [d, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
          // Firefox OS
        ],
        [y, [d, j + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
          // WebOS
        ],
        [y, [d, "webOS"]],
        [
          /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
          // watchOS
        ],
        [y, [d, "watchOS"]],
        [
          // Google Chromecast
          /crkey\/([\d\.]+)/i
          // Google Chromecast
        ],
        [y, [d, Z + "cast"]],
        [
          /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
          // Chromium OS
        ],
        [[d, x], y],
        [
          // Smart TVs
          /panasonic;(viera)/i,
          // Panasonic Viera
          /(netrange)mmh/i,
          // Netrange
          /(nettv)\/(\d+\.[\w\.]+)/i,
          // NetTV
          // Console
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          // Nintendo/Playstation
          /(xbox); +xbox ([^\);]+)/i,
          // Microsoft Xbox (360, One, X, S, Series X, Series S)
          // Other
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          // Joli/Palm
          /(mint)[\/\(\) ]?(\w*)/i,
          // Mint
          /(mageia|vectorlinux)[; ]/i,
          // Mageia/VectorLinux
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
          /(hurd|linux) ?([\w\.]*)/i,
          // Hurd/Linux
          /(gnu) ?([\w\.]*)/i,
          // GNU
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
          /(haiku) (\w+)/i
          // Haiku
        ],
        [d, y],
        [
          /(sunos) ?([\w\.\d]*)/i
          // Solaris
        ],
        [[d, "Solaris"], y],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          // Solaris
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          // AIX
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
          // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
          /(unix) ?([\w\.]*)/i
          // UNIX
        ],
        [d, y]
      ]
    }, he = function(z, Q) {
      if (typeof z === l && (Q = z, z = n), !(this instanceof he))
        return new he(z, Q).getResult();
      var U = typeof r !== m && r.navigator ? r.navigator : n, ee = z || (U && U.userAgent ? U.userAgent : a), Te = U && U.userAgentData ? U.userAgentData : n, Re = Q ? N(je, Q) : je, te = U && U.userAgent == ee;
      return this.getBrowser = function() {
        var W = {};
        return W[d] = n, W[y] = n, be.call(W, ee, Re.browser), W[b] = de(W[y]), te && U && U.brave && typeof U.brave.isBrave == i && (W[d] = "Brave"), W;
      }, this.getCPU = function() {
        var W = {};
        return W[S] = n, be.call(W, ee, Re.cpu), W;
      }, this.getDevice = function() {
        var W = {};
        return W[u] = n, W[c] = n, W[v] = n, be.call(W, ee, Re.device), te && !W[v] && Te && Te.mobile && (W[v] = h), te && W[c] == "Macintosh" && U && typeof U.standalone !== m && U.maxTouchPoints && U.maxTouchPoints > 2 && (W[c] = "iPad", W[v] = g), W;
      }, this.getEngine = function() {
        var W = {};
        return W[d] = n, W[y] = n, be.call(W, ee, Re.engine), W;
      }, this.getOS = function() {
        var W = {};
        return W[d] = n, W[y] = n, be.call(W, ee, Re.os), te && !W[d] && Te && Te.platform != "Unknown" && (W[d] = Te.platform.replace(/chrome os/i, x).replace(/macos/i, k)), W;
      }, this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      }, this.getUA = function() {
        return ee;
      }, this.setUA = function(W) {
        return ee = typeof W === f && W.length > A ? me(W, A) : W, this;
      }, this.setUA(ee), this;
    };
    he.VERSION = o, he.BROWSER = R([d, y, b]), he.CPU = R([S]), he.DEVICE = R([c, u, v, w, h, p, g, P, _]), he.ENGINE = he.OS = R([d, y]), e.exports && (t = e.exports = he), t.UAParser = he;
    var Se = typeof r !== m && (r.jQuery || r.Zepto);
    if (Se && !Se.ua) {
      var Ue = new he();
      Se.ua = Ue.getResult(), Se.ua.get = function() {
        return Ue.getUA();
      }, Se.ua.set = function(z) {
        Ue.setUA(z);
        var Q = Ue.getResult();
        for (var U in Q)
          Se.ua[U] = Q[U];
      };
    }
  })(typeof window == "object" ? window : Sa);
})(pr, pr.exports);
var ys = pr.exports;
const kr = /* @__PURE__ */ Ra(ys), vs = "desktop", ms = (e) => {
  if (!e)
    return "";
  const t = new kr(e), { type: r } = t.getDevice();
  return r ?? vs;
}, bs = (e) => {
  if (!e)
    return null;
  const t = new kr(e), { name: r, version: n } = t.getBrowser();
  return { name: r, version: n };
}, hs = (e) => {
  if (!e)
    return null;
  const t = new kr(e), { name: r, version: n } = t.getOS();
  return { name: r, version: n };
}, gs = () => typeof crypto > "u" ? null : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(
  /[018]/g,
  (e) => (e ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> e / 4).toString(16)
);
function va({ name: e, category: t = na }) {
  return {
    category: t,
    action: e
  };
}
const ws = (e = [], t, r) => {
  const n = hs(r), o = bs(r);
  return e.includes(t) ? {
    os_name: n == null ? void 0 : n.name,
    os_version: n == null ? void 0 : n.version,
    user_agent_name: o == null ? void 0 : o.name,
    user_agent_version: o == null ? void 0 : o.version
  } : {};
};
let ko = !1;
const Es = async ({
  category: e = na,
  name: t,
  parameters: r = {},
  value: n,
  withGa: o,
  ...a
}) => {
  const {
    brandId: s = Qi,
    platformId: i = Ji,
    systemEventsNames: m = [],
    apiKey: l,
    locale: f = Ki,
    userAgent: b,
    appVersion: c,
    countryId: d
  } = await Sr.get(), v = await ds(l), u = ws(m, t, b), y = ms(b);
  let S = {};
  ko || (S = Xi(window.location.href), ko = !0);
  const w = o ? va({ category: e, name: t }) : null;
  return {
    brandId: s,
    category: e,
    gaEventData: w,
    name: t,
    value: n,
    app_version: c,
    client_time: Date.now(),
    device_id: v,
    parameters: {
      device: y,
      locale: f,
      country_id: d,
      ...r,
      ...u,
      ...S
    },
    platform_id: i,
    uuid: gs(),
    ...a
  };
}, Ss = () => {
  const e = $e((o) => Es(o), []), t = $e(
    (o) => va(o),
    []
  ), r = $e(async (o) => {
    const { brandId: a, gaEventData: s, ...i } = o;
    try {
      bo(s), await Ui(i, a);
    } catch (m) {
      console.error(m);
    }
  }, []), n = $e((o) => {
    try {
      bo(o);
    } catch (a) {
      console.error(a);
    }
  }, []);
  return {
    createEventData: e,
    createGaEventData: t,
    sendEvent: async (o) => {
      await r(o);
    },
    sendGaEvent: n
  };
}, Rs = async () => {
  const { errorCallback: e } = await Sr.get();
  e && vt.setResponseErrorCallback(e);
}, Os = () => {
  if (typeof window < "u") {
    const { userAgent: e } = window.navigator;
    Sr.set({ userAgent: e });
  }
  return Rs(), Ss();
}, _s = () => {
  const { sendEvent: e, createEventData: t, createGaEventData: r, sendGaEvent: n } = Os(), { trackEvent: o, Track: a } = cr.useTracking({}, { dispatch: e }), { trackEvent: s, Track: i } = cr.useTracking({}, { dispatch: n }), m = $e(
    async (f) => {
      try {
        const b = await t(f);
        if (!b) {
          console.error("can not track");
          return;
        }
        o(b);
      } catch (b) {
        console.error("sending event failed for this reason:", b);
      }
    },
    [t, o]
  ), l = $e(
    (f) => {
      const b = r(f);
      if (!b) {
        console.error("can not track ga");
        return;
      }
      return s(b);
    },
    [s, r]
  );
  return {
    TrackGaComponent: i,
    TrackComponent: a,
    sendEvent: m,
    sendGaEvent: l
  };
}, ma = ga({
  sendEvent: () => {
    throw new Error("Not implemented `sendEvent`");
  },
  sendGaEvent: () => {
    throw new Error("Not implemented `sendGaEvent`");
  }
}), Cs = () => wa(ma), Ts = Ea(({ children: e }) => {
  const { sendEvent: t, TrackComponent: r, TrackGaComponent: n, sendGaEvent: o } = _s(), a = {
    sendEvent: t,
    sendGaEvent: o
  };
  return /* @__PURE__ */ Ge.createElement(ma.Provider, { value: a }, /* @__PURE__ */ Ge.createElement(r, null, /* @__PURE__ */ Ge.createElement(n, null, e)));
});
Ts.displayName = "AnalyticsProvider";
const xs = (e) => tt.isInitialized && tt.send({ page: e, hitType: "pageview" });
export {
  Ts as AnalyticsProvider,
  xs as gApageView,
  $i as initConfig,
  Cs as useAnalyticsContext,
  _s as useEvents
};
//# sourceMappingURL=affiliate-frontend-analytics-events.js.map
